<template>
    <panel-navigation>
            <call-modal ref="CallModal"></call-modal>
            <dialog-request-review ref="dialogRequestReview"></dialog-request-review>

            <div v-if="show_analysis_dialog" @click.self="show_analysis_dialog = false" class="fixed top-0 left-0 h-full w-full z-50 flex flex-column items-center justify-center" style="background-color: rgba(0,0,0,.2);">
                <div class="w-full sm:w-1/3 lg:w-1/3 bg-white rounded-lg mx-6">

                    <div class="rg-modal-header">
                    Run Analysis

                    <a href="javascript: void(0);" class="rg-modal-close-btn" @click="show_analysis_dialog = false"><i class="mdi mdi-close"></i></a>
                    </div>

                    <div class="p-6" style="position: relative;">

                    <div class="float-right -mb-4" style="position: relative;">
                        <!-- <a href="https://www.bland.ai/" class="text-xs" target="lsa-bland-link">Sign Up for Bland</a> -->
                    </div>

                    <div style="clear: both;"></div>

                    <div v-for="(item, index) in analyze_queries" :key="'analyze-query-' + index" style="padding-bottom: 5px;">
                        <div style="float: left; width: calc(100% - 130px);">
                            <input type="text" v-model="item.description" placeholder="What was the sentiment of the person called?" style="padding: 5px; border-radius: 3px; border: solid 1px #00000031; font-size: 12px; width: 100%;" />
                        </div>

                        <div style="float: left; width: 100px; padding-left: 10px;">
                            <select v-model="item.type" style="padding: 5px; border-radius: 3px; border: solid 1px #00000031; font-size: 12px; width: 100%;">
                                <option value="string">Text</option>
                                <option value="boolean">True/False</option>
                                <option value="int">Number</option>
                            </select>
                        </div>

                        <div style="float: left; width: 20px; padding-left: 10px; text-align: right;">
                            <i v-if="index == 0" class="mdi mdi-delete" style="cursor: not-allowed;"></i>
                            <i v-else class="mdi mdi-delete" @click="deleteAnalyzeQuery(index)" style="color: red; cursor: pointer;"></i>
                        </div>

                        <div style="clear: both;"></div>
                    </div>

                    <button class="rounded text-blue text-xs text-bold border border-blue focus:outline-none py-2 px-4 mr-2 w-full mb-2" @click="addAnalysisItem();">
                        + Add New Analysis Item
                    </button>

                    <button class="rg-dialog-button-save rounded text-white text-xs text-bold focus:outline-none py-2 px-4 w-full mb-2" :class="{'spinner': runningAnalysis}" @click="runAnalysis()">
                        Run Analysis
                    </button>

                    <div v-if="analysis_totals" style="max-height: 600px; overflow: auto;">
                        <div v-for="(item, index) in analysis_totals" :key="'analyze-total-' + index" style="border: 1.5px solid rgb(232, 232, 232); padding: 10px; margin-top: 5px; margin-bottom: 5px; border-radius: 5px;">
                            <p style="font-size: 14px; font-weight: 500;">{{ index }}</p>

                            <div v-for="(item2, index2) in item" :key="'analyze-total-item-' + index2" style="display: flex; flex-direction: row; align-items: center; justify-content: space-between; width: 100%; padding-top: 3px; border-bottom: 1px solid rgb(238, 238, 238); font-size: 12px;">
                                <p style="max-width: 70%; overflow-x: clip;">{{ index2 }}</p>
                                <p>{{ item2 }}</p>
                            </div>
                        </div>
                    </div>

                    </div>

                    <div class="bg-gray-100 rounded-b-lg px-6 py-4">

                    <button class="rounded text-blue text-xs text-bold border border-blue focus:outline-none py-2 px-4 mr-2 float-right" @click="show_analysis_dialog = false">
                        CLOSE
                    </button>

                    <div class="clearfix"></div>

                    </div>

                </div>
            </div>

            <div v-if="showAddTag" @click.self="showAddTag = false" class="fixed top-0 left-0 h-full w-full z-50 flex flex-column items-center justify-center" style="background-color: rgba(0,0,0,.2);">
                <div class="w-full sm:w-1/4 lg:w-1/4 bg-white rounded-lg mx-6">

                    <div class="rg-modal-header">
                    Add Tag

                    <a href="javascript: void(0);" class="rg-modal-close-btn" @click="showAddTag = false"><i class="mdi mdi-close"></i></a>
                    </div>

                    <div class="p-6" style="position: relative;">

                    <div class="float-right -mb-4" style="position: relative;">
                        <!-- <a href="https://www.bland.ai/" class="text-xs" target="lsa-bland-link">Sign Up for Bland</a> -->
                    </div>

                    <div style="clear: both;"></div>

                    <div class="flex flex-row flex-wrap">
                        <div :class="'w-full mb-3'">
                            <p class="mb-1 text-xs mb-2"><strong>New Tag</strong></p>
                            <input v-model="new_tag" class="rg-text-field block appearance-none focus:outline-none focus:border-gray-500 w-full bg-white hover:border-grey px-2 py-2 rounded" style="padding-right: 35px !important;"
                                :class="(($vuetify.breakpoint.xs) ? 'mb-2' : '')"
                                placeholder="Enter tag here"
                            />

                            <p class="text-sm text-gray-600 pt-2">
                                Enter a custom tag
                            </p>
                        </div>
                        <div :class="'w-full mb-3'">
                            <p class="mb-1 text-xs mb-2"><strong>Tag Color</strong></p>
                            <input v-model="new_tag_color" class="rg-text-field block appearance-none focus:outline-none focus:border-gray-500 w-full bg-white hover:border-grey px-2 py-2 rounded" style="padding-right: 35px !important; width: 100px;"
                                :class="(($vuetify.breakpoint.xs) ? 'mb-2' : '')"
                                type="color"
                                placeholder="#000000"
                            />

                            <p class="text-sm text-gray-600 pt-2">
                                Specify a custom color for this tag
                            </p>
                        </div>
                    </div>

                    </div>

                    <div class="bg-gray-100 rounded-b-lg px-6 py-4">

                    <button class="rg-dialog-button-save rounded text-white text-xs text-bold focus:outline-none py-2 px-4 float-right" :class="{'spinner': savingTag}" @click="saveTag">
                        Save
                    </button>

                    <button class="rounded text-blue text-xs text-bold border border-blue focus:outline-none py-2 px-4 mr-2 float-right" @click="showAddTag = false">
                        CLOSE
                    </button>

                    <div class="clearfix"></div>

                    </div>

                </div>
                </div>

            <div v-if="showAddStatus" @click.self="showAddStatus = false" class="fixed top-0 left-0 h-full w-full z-50 flex flex-column items-center justify-center" style="background-color: rgba(0,0,0,.2);">
                <div class="w-full sm:w-1/4 lg:w-1/4 bg-white rounded-lg mx-6">

                    <div class="rg-modal-header">
                    Add Custom Status

                    <a href="javascript: void(0);" class="rg-modal-close-btn" @click="showAddStatus = false"><i class="mdi mdi-close"></i></a>
                    </div>

                    <div class="p-6" style="position: relative;">

                    <div class="float-right -mb-4" style="position: relative;">
                        <!-- <a href="https://www.bland.ai/" class="text-xs" target="lsa-bland-link">Sign Up for Bland</a> -->
                    </div>

                    <div style="clear: both;"></div>

                    <div class="flex flex-row flex-wrap">
                        <div :class="'w-full mb-3'">
                            <p class="mb-1 text-xs mb-2"><strong>New Status</strong></p>
                            <input v-model="new_status" class="rg-text-field block appearance-none focus:outline-none focus:border-gray-500 w-full bg-white hover:border-grey px-2 py-2 rounded" style="padding-right: 35px !important;"
                                :class="(($vuetify.breakpoint.xs) ? 'mb-2' : '')"
                                placeholder="Enter status here"
                            />

                            <p class="text-sm text-gray-600 pt-2">
                                Enter a custom status
                            </p>
                        </div>
                        <div :class="'w-full mb-3'">
                            <p class="mb-1 text-xs mb-2"><strong>Status Color</strong></p>
                            <input v-model="new_status_color" class="rg-text-field block appearance-none focus:outline-none focus:border-gray-500 w-full bg-white hover:border-grey px-2 py-2 rounded" style="padding-right: 35px !important; width: 100px;"
                                :class="(($vuetify.breakpoint.xs) ? 'mb-2' : '')"
                                type="color"
                                placeholder="#000000"
                            />

                            <p class="text-sm text-gray-600 pt-2">
                                Specify a custom color for this status
                            </p>
                        </div>
                    </div>

                    </div>

                    <div class="bg-gray-100 rounded-b-lg px-6 py-4">

                    <button class="rg-dialog-button-save rounded text-white text-xs text-bold focus:outline-none py-2 px-4 float-right" :class="{'spinner': savingStatus}" @click="saveStatus">
                        Save
                    </button>

                    <button class="rounded text-blue text-xs text-bold border border-blue focus:outline-none py-2 px-4 mr-2 float-right" @click="showAddStatus = false">
                        CLOSE
                    </button>

                    <div class="clearfix"></div>

                    </div>

                </div>
            </div>

            <div v-if="showCallRailRecording" @click.self="showCallRailRecording = false" class="fixed top-0 left-0 h-full w-full z-50 flex flex-column items-center justify-center" style="background-color: rgba(0,0,0,.2);">
                <div class="w-full sm:w-1/3 lg:w-1/3 bg-white rounded-lg mx-6" style="max-height: 100%;">

                    <div class="rg-modal-header">
                    Show Recording

                    <a href="javascript: void(0);" class="rg-modal-close-btn" @click="showCallRailRecording = false"><i class="mdi mdi-close"></i></a>
                    </div>

                    <div class="p-6" style="position: relative; height: calc(100% - 110px); overflow: auto;">

                    <div class="float-right -mb-4" style="position: relative;">
                        <!-- <a href="https://www.bland.ai/" class="text-xs" target="lsa-bland-link">Sign Up for Bland</a> -->
                    </div>

                    <div style="clear: both;"></div>

                    <div>
                        <div v-if="loading_callrail_recording" :class="'w-full mb-3'">
                            <v-skeleton-loader type="article, article, article"></v-skeleton-loader>
                        </div>
                        <div class="flex flex-row flex-wrap" v-else>
                            <div class="w-full mb-4">
                                <!-- <iframe :src="callrail_recording_data.recording_url" style="width: 100%; height: 500px; border: 0px;"></iframe> -->
                                <div id="cr-audio-el-here"></div>
                            </div>
                            <div class="w-full">
                                <hr />
                                <div style="max-height: 500px; overflow: auto;">
                                    <div v-if="!callrail_recording_data.transcription" class="text-sm" style="text-align: center;">
                                        <br />
                                        No transcription available.
                                    </div>
                                    <div v-else>
                                        <b-list-group>
                                            <b-list-group-item

                                                v-for="(item, index) in callrail_recording_data.transcription" :key="index"
                                        
                                                    class="d-flex align-items-center mb-4 pb-4"
                                                    style="border: none; border-bottom: solid 1px #ededed;"
                                            >
                                                <b-avatar v-if="item.speaker == 'agent'"
                                                        text="S1"
                                                        class="mr-3 call-info-avatar"
                                                ></b-avatar>
                                                <b-avatar v-if="item.speaker == 'caller'"
                                                        text="S2"
                                                        class="mr-3 call-info-avatar"
                                                ></b-avatar>
                                                <div>
                                                    <span v-if="item.speaker == 'agent'" class="mr-auto primary-color text-bold">AI AGENT</span>
                                                    <span v-else class="mr-auto warning-color text-bold">Caller</span>

                                                    <span class="mr-auto"> . {{ displaySpeakerTimestamp(item.start*1000) }} . </span>
                                                    <!-- <span v-if="item.sentiment == 'Neutral'" class="mr-auto warning-color text-bold">Neutral</span>
                                                    <span v-if="item.sentiment == 'Positive'" class="mr-auto success-color text-bold">Positive</span>
                                                    <span v-if="item.sentiment == 'Negative'" class="mr-auto danger-color text-bold">Negative</span> -->
                                                    <div class="text-sm">{{ item.phrase }}</div>
                                                </div>
                                            </b-list-group-item>
                                        </b-list-group>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    </div>

                    <div class="bg-gray-100 rounded-b-lg px-6 py-4">

                    <button class="rounded text-blue text-xs text-bold border border-blue focus:outline-none py-2 px-4 mr-2 float-right" @click="showCallRailRecording = false">
                        CLOSE
                    </button>

                    <div class="clearfix"></div>

                    </div>

                </div>
            </div>

            <div v-if="showBlandRecording" @click.self="showBlandRecording = false" class="fixed top-0 left-0 h-full w-full z-50 flex flex-column items-center justify-center" style="background-color: rgba(0,0,0,.2);">
                <div class="w-full sm:w-2/3 lg:w-2/3 bg-white rounded-lg mx-6" style="max-height: 100%;">

                    <div class="p-6" style="position: relative; height: calc(100% - 20px); overflow: auto;">

                    <div class="float-right -mb-4" style="position: relative;">
                        <!-- <a href="https://www.bland.ai/" class="text-xs" target="lsa-bland-link">Sign Up for Bland</a> -->

                        <button class="rounded text-blue text-xs text-bold border border-blue focus:outline-none py-2 px-4 mr-2 float-right" @click="translateTexts('bland', 'spanish')">
                            <i class="mdi mdi-text-box-edit-outline"></i> TRANSLATE TO ENGLISH
                        </button>
                    </div>

                    <div style="clear: both; padding-top: 10px;"></div>

                    <div>
                        <div v-if="loading_bland_recording" :class="'w-full mb-3'">
                            <v-skeleton-loader type="article, article, article"></v-skeleton-loader>
                        </div>
                        <div class="flex flex-row flex-wrap" v-else>
                            <div class="w-full mb-4">
                                <!-- <iframe :src="bland_recording_data.recording_url" style="width: 100%; height: 500px; border: 0px;"></iframe> -->
                                <div id="bl-audio-el-here"></div>
                            </div>
                            <div class="w-full">
                                <hr />
                                <div id="ai-dialog-messages-list"  style="max-height: 500px; overflow: auto;">

                                    <div v-if="!bland_recording_data.transcription" class="text-sm" style="text-align: center;">
                                        <br />
                                        No transcription available.
                                    </div>
                                    <div v-else>
                                        <div v-if="!bland_recording_data.transcription.messages">
                                            <div class="flex flex-row flex-wrap w-full">
                                                <div :class="'w-full lg:w-1/2'">
                                                    <div style="font-weight: bold; padding-top: 10px; padding-bottom: 10px;">Transcription</div>

                                                    <br />
                                                    <div>
                                                        <b-list-group>
                                                            <b-list-group-item
                                                                v-for="(item, index) in bland_recording_data.transcription" :key="index"
                                                        
                                                                    class="d-flex align-items-center mb-4 pb-4"
                                                                    style="border: none; border-bottom: solid 1px #ededed;"
                                                            >
                                                                <b-avatar v-if="item.speaker == 'A'"
                                                                        text="S1"
                                                                        class="mr-3 call-info-avatar"
                                                                ></b-avatar>
                                                                <b-avatar v-if="item.speaker == 'B'"
                                                                        text="S2"
                                                                        class="mr-3 call-info-avatar"
                                                                ></b-avatar>
                                                                <div>
                                                                    <span v-if="item.speaker == 'A'" class="mr-auto primary-color text-bold">AI</span>
                                                                    <span v-else class="mr-auto warning-color text-bold">Caller</span>

                                                                    <span class="mr-auto"> . {{ displaySpeakerTimestamp(item.start) }} . </span>
                                                                    <!-- <span v-if="item.sentiment == 'Neutral'" class="mr-auto warning-color text-bold">Neutral</span>
                                                                    <span v-if="item.sentiment == 'Positive'" class="mr-auto success-color text-bold">Positive</span>
                                                                    <span v-if="item.sentiment == 'Negative'" class="mr-auto danger-color text-bold">Negative</span> -->
                                                                    <div class="text-sm">{{ item.text }}</div>
                                                                </div>
                                                            </b-list-group-item>
                                                        </b-list-group>
                                                    </div>
                                                </div>
                                                <div :class="'w-full lg:w-1/2 pl-3'">
                                                    <div style="font-weight: bold; padding-top: 10px; padding-bottom: 10px;">Summary</div>

                                                    <div style="font-size: 12px;">{{ bland_recording_data.summary || "No summary found." }}</div>

                                                    <!-- <div style="font-weight: bold; padding-top: 10px; padding-bottom: 10px;">Sentiment</div>

                                                    <div style="font-size: 12px;">{{ bland_recording_data.sentiment || "UNKNOWN" }}</div>

                                                    <div style="font-weight: bold; padding-top: 10px; padding-bottom: 10px;">Topics Discussed</div>

                                                    <div style="font-size: 12px;">{{ bland_recording_data.topics_discussed || "No topics discussed." }}</div>

                                                    <div style="font-weight: bold; padding-top: 10px; padding-bottom: 10px;">Issues Raised</div>

                                                    <div style="font-size: 12px;">{{ bland_recording_data.issues_raised || "No issues raised." }}</div> -->

                                                    <div style="font-weight: bold; padding-top: 10px; padding-bottom: 10px;">Customer Information</div>

                                                    <div style="font-size: 12px;">
                                                        <strong>Customer's name:</strong> {{ bland_recording_data.customer_name || "-" }}
                                                        <br />
                                                        <strong>Customer's email:</strong> {{ bland_recording_data.customer_email || "-" }}
                                                        <br />
                                                        <strong>Customer's phone:</strong> {{ bland_recording_data.ai_provided_phone_number || "-" }}
                                                        <br />
                                                        <strong>Service needed:</strong> {{ bland_recording_data.job_type || "-" }}
                                                        <br /><br />
                                                        <strong>Call ended by:</strong> {{ bland_recording_data.call_ended_by || "-" }}
                                                    </div>

                                                    <!--<div style="font-weight: bold; padding-top: 10px; padding-bottom: 10px;">Analysis</div>

                                                    <div v-if="bland_recording_data.analysis" style="font-size: 12px;">
                                                        <div v-for="(item, index) in bland_recording_data.analysis" :key="'variable-' + index">
                                                            <strong>{{ index }}: </strong> {{ item }} <br />
                                                        </div>
                                                    </div>
                                                    <div v-else style="font-size: 12px;">No analysis detected.</div>-->

                                                    <div style="font-weight: bold; padding-top: 10px; padding-bottom: 10px;">Variables</div>

                                                    <div v-if="bland_recording_data.variables" style="font-size: 12px;">
                                                        <div v-for="(item, index) in bland_recording_data.variables" :key="'variable-' + index">
                                                            <strong>{{ index }}: </strong> {{ item }} <br />
                                                        </div>
                                                    </div>
                                                    <div v-else style="font-size: 12px;">No variables.</div>
                                                </div>
                                            </div>
                                        </div>
                                        <div v-else>
                                            <b-list-group>
                                                <b-list-group-item
                                                    v-for="(item, index) in bland_recording_data.transcription.messages" :key="index"
                                            
                                                        class="d-flex align-items-center mb-4 pb-4"
                                                        style="border: none; border-bottom: solid 1px #ededed;"
                                                >

                                                    <b-avatar v-if="(!item.is_bland && item.sender != 'bot') || item.is_person"
                                                            text="S1"
                                                            class="mr-3 call-info-avatar"
                                                    ></b-avatar>
                                                    <b-avatar v-if="(item.is_bland || item.sender == 'bot') && !item.is_person"
                                                            text="S2"
                                                            class="mr-3 call-info-avatar"
                                                    ></b-avatar>
                                                    <div>
                                                        <span v-if="item.is_person" class="mr-auto primary-color text-bold">{{ me.first_name }} {{ me.last_name }}</span>
                                                        <span v-if="(item.is_bland || item.sender == 'bot') && !item.is_person" class="mr-auto primary-color text-bold">AI Agent</span>
                                                        <span v-if="!item.is_bland && item.sender != 'bot' && !item.is_person" class="mr-auto warning-color text-bold">Customer</span>

                                                        <span class="mr-auto text-xs text-gray-600"> . {{ displayTimestamp(item.timestamp) }} . </span>
                                                        <!-- <span v-if="item.sentiment == 'Neutral'" class="mr-auto warning-color text-bold">Neutral</span>
                                                        <span v-if="item.sentiment == 'Positive'" class="mr-auto success-color text-bold">Positive</span>
                                                        <span v-if="item.sentiment == 'Negative'" class="mr-auto danger-color text-bold">Negative</span> -->
                                                        <div class="text-sm">
                                                            {{ item.message }}

                                                            <ReinforcementLearning v-if="item.is_bland && !item.is_person" :message="item.message" />
                                                        </div>
                                                    </div>
                                                </b-list-group-item>
                                            </b-list-group>
                                        </div>
                                    </div>
                                </div>

                                <div v-show="bland_recording_data.transcription.messages" class="mt-4 -mb-12">
                                    <v-text-field
                                        clearable
                                        outlined
                                        dense
                                        hide-details
                                        label="Reply"
                                        v-model="new_ai_message"

                                        class="white border border-white"
                                    ></v-text-field>
                                </div>
                            </div>
                        </div>
                    </div>

                    </div>

                    <div class="bg-gray-100 rounded-b-lg px-6 py-4">

                    <button class="rounded text-blue text-xs text-bold border border-blue focus:outline-none py-2 px-4 mr-2 float-right" @click="showBlandRecording = false">
                        CLOSE
                    </button>

                    <button
                            class="rg-dialog-button-save custom-button rounded bg-gray-500 hover:bg-gray-600 text-white focus:outline-none py-2 px-4 float-left"
                            :class="{ spinner: sendingAiMessage }"
                            @click="sendAiReply()"
                            :disabled="!new_ai_message"
                    >
                        SEND
                    </button>

                    <div style="float: right; padding-right: 30px; padding-top: 6px;">
                        <v-switch color="#48bb78" inset dense hide-details :ripple="false" v-model="ai_messages_lead.ai_enabled" label="AI Response Enabled" @change="switchAiResponseEnabled(ai_messages_lead);"></v-switch>
                    </div>

                    <div class="clearfix"></div>

                    </div>

                </div>
            </div>

            <div v-if="showLsaRecordings" @click.self="showLsaRecordings = false" class="fixed top-0 left-0 h-full w-full z-50 flex flex-column items-center justify-center" style="background-color: rgba(0,0,0,.2);">
                <div class="w-full sm:w-1/3 lg:w-1/3 bg-white rounded-lg mx-6" style="max-height: 100%;">

                    <div class="p-6" style="position: relative; height: calc(100% - 20px); overflow: auto;">

                    <div class="float-right -mb-4" style="position: relative;">
                        <!-- <a href="https://www.bland.ai/" class="text-xs" target="lsa-bland-link">Sign Up for Bland</a> -->
                    </div>

                    <div style="clear: both;"></div>

                    <div>
                        <div v-if="loading_lsa_recordings" :class="'w-full mb-3'">
                            <v-skeleton-loader type="article, article, article"></v-skeleton-loader>
                        </div>
                        <div class="flex flex-row flex-wrap" v-else>
                            <div class="w-full mb-4">
                                <!-- <iframe :src="bland_recording_data.recording_url" style="width: 100%; height: 500px; border: 0px;"></iframe> -->
                                <div id="lsa-audio-el-here"></div>

                                <div class="bg-blue-100 border-l-4 border-blue-500 text-blue-700 p-4 mb-4" role="alert">
                                    <div>According to Google's policy, you must be logged in to your LSA account in this browser. Please make sure you are logged in on <a href="https://ads.google.com/localservices" target="lsa-account-login">https://ads.google.com/localservices</a> in order to play the recordings in your software.</div>
                                </div>
                            </div>
                        </div>
                    </div>

                    </div>

                    <div class="bg-gray-100 rounded-b-lg px-6 py-4">

                    <button class="rounded text-blue text-xs text-bold border border-blue focus:outline-none py-2 px-4 mr-2 float-right" @click="showLsaRecordings = false">
                        CLOSE
                    </button>

                    <div class="clearfix"></div>

                    </div>

                </div>
            </div>

            <div v-if="showLsaMessages" @click.self="showLsaMessages = false" class="fixed top-0 left-0 h-full w-full z-50 flex flex-column items-center justify-center" style="background-color: rgba(0,0,0,.2);">
                <div class="w-full sm:w-1/3 lg:w-1/3 bg-white rounded-lg mx-6" style="max-height: 100%;">

                    <div class="p-6" style="position: relative; height: calc(100% - 65px); overflow: auto;">

                    <div class="float-right -mb-4" style="position: relative;">
                        <!-- <a href="https://www.bland.ai/" class="text-xs" target="lsa-bland-link">Sign Up for Bland</a> -->
                    </div>

                    <div style="clear: both;"></div>

                    <div>
                        <div v-if="loading_lsa_messages" :class="'w-full mb-3'">
                            <v-skeleton-loader type="article, article, article"></v-skeleton-loader>
                        </div>
                        <div class="flex flex-row flex-wrap" v-else>
                            <div class="w-full">
                                <div id="lsa-dialog-messages-list" style="max-height: 450px; overflow: auto;">
                                    <div v-if="lsa_messages_displayed.length == 0" class="text-sm" style="text-align: center;">
                                        <br />
                                        No transcription available.
                                    </div>
                                    <div v-else>
                                        <b-list-group>
                                            <b-list-group-item

                                                v-for="(item, index) in lsa_messages_displayed" :key="index"
                                        
                                                    class="d-flex align-items-center mb-4 pb-4"
                                                    style="border: none; border-bottom: solid 1px #ededed;"
                                            >
                                                <b-avatar v-if="item.participant_type == 2"
                                                        text="S1"
                                                        class="mr-3 call-info-avatar"
                                                ></b-avatar>
                                                <b-avatar v-if="item.participant_type == 3"
                                                        text="S2"
                                                        class="mr-3 call-info-avatar"
                                                ></b-avatar>
                                                <div>
                                                    <span v-if="item.participant_type == 2" class="mr-auto primary-color text-bold">Advertiser</span>
                                                    <span v-else class="mr-auto warning-color text-bold">Customer</span>

                                                    <span class="mr-auto text-xs text-gray-600"> . {{ displayTimestamp(item.event_time) }} . </span>
                                                    <div class="text-sm" v-html="item.text"></div>
                                                </div>
                                            </b-list-group-item>
                                        </b-list-group>
                                    </div>
                                </div>

                                <div>
                                    <v-text-field
                                        clearable
                                        outlined
                                        dense
                                        hide-details
                                        label="Reply"
                                        v-model="new_lsa_message"

                                        class="white border border-white"
                                    ></v-text-field>
                                </div>
                            </div>
                        </div>
                    </div>

                    </div>

                    <div class="bg-gray-100 rounded-b-lg px-6 py-4">

                    <button class="rounded text-blue text-xs text-bold border border-blue focus:outline-none py-2 px-4 mr-2 float-right" @click="showLsaMessages = false">
                        CLOSE
                    </button>

                    <button
                            class="rg-dialog-button-save custom-button rounded bg-gray-500 hover:bg-gray-600 text-white focus:outline-none py-2 px-4"
                            :class="{ spinner: sendingLsaMessage }"
                            @click="sendLsaReply()"
                            :disabled="!new_lsa_message"
                    >
                        SEND
                    </button>

                    <div class="clearfix"></div>

                    </div>

                </div>
            </div>

            <div v-if="show_notes_dialog" @click.self="show_notes_dialog = false" class="fixed top-0 left-0 h-full w-full z-50 flex flex-column items-center justify-center" style="background-color: rgba(0,0,0,.2);">
                <div class="w-full sm:w-1/3 lg:w-1/3 bg-white rounded-lg mx-6" style="max-height: 100%;">

                    <div class="rg-modal-header">
                        Notes

                        <a href="javascript: void(0);" class="rg-modal-close-btn" @click="show_notes_dialog = false"><i class="mdi mdi-close"></i></a>
                    </div>

                    <div class="p-6" style="position: relative; overflow: auto;">

                        <div style="clear: both;"></div>

                        <div>

                            <div style="font-size: 12px; padding-bottom: 20px;">
                                <div v-if="notes_lead.notes.length == 0">
                                    No notes found.
                                </div>

                                <div v-else>
                                    <div v-for="(note, note_index) in notes_lead.notes" style="clear: both; padding-bottom: 10px;">
                                        <div style="float: left; width: calc(100% - 220px);">
                                            {{ note.note }}
                                        </div>

                                        <div style="float: right; width: 200px; text-align: right;">
                                            [{{ formatDate(note.timestamp) }}]

                                            &nbsp;&nbsp;

                                            <a href="javascript: void(0);"><i class="mdi mdi-delete-outline" style="color: red;" @click="deleteNote(note_index)"></i></a>
                                        </div>

                                        <div style='clear: both;'></div>
                                    </div>

                                    <div style='clear: both;'></div>
                                </div>
                            </div>

                            <v-text-field
                                clearable
                                outlined
                                dense
                                hide-details
                                label="Add Note"
                                v-model="new_note"

                                class="white border border-white"
                            ></v-text-field>
                            
                        </div>

                    </div>

                    <div class="bg-gray-100 rounded-b-lg px-6 py-4">

                        <button class="rg-dialog-button-save rounded text-white text-xs text-bold focus:outline-none py-2 px-4 float-right" :class="{'spinner': savingNote}" @click="saveNote">
                            ADD
                        </button>

                        <button class="rounded text-blue text-xs text-bold border border-blue focus:outline-none py-2 px-4 mr-2 float-right" @click="show_notes_dialog = false">
                            CLOSE
                        </button>

                    <div class="clearfix"></div>

                    </div>
                </div>
            </div>

            <div v-if="showAddStatus" @click.self="showAddStatus = false" class="fixed top-0 left-0 h-full w-full z-50 flex flex-column items-center justify-center" style="background-color: rgba(0,0,0,.2);">
                <div class="w-full sm:w-1/4 lg:w-1/4 bg-white rounded-lg mx-6">

                    <div class="rg-modal-header">
                    Add Custom Status

                    <a href="javascript: void(0);" class="rg-modal-close-btn" @click="showAddStatus = false"><i class="mdi mdi-close"></i></a>
                    </div>

                    <div class="p-6" style="position: relative;">

                    <div class="float-right -mb-4" style="position: relative;">
                        <!-- <a href="https://www.bland.ai/" class="text-xs" target="lsa-bland-link">Sign Up for Bland</a> -->
                    </div>

                    <div style="clear: both;"></div>

                    <div class="flex flex-row flex-wrap">
                        <div :class="'w-full mb-3'">
                            <p class="mb-1 text-xs mb-2"><strong>New Status</strong></p>
                            <input v-model="new_status" class="rg-text-field block appearance-none focus:outline-none focus:border-gray-500 w-full bg-white hover:border-grey px-2 py-2 rounded" style="padding-right: 35px !important;"
                                :class="(($vuetify.breakpoint.xs) ? 'mb-2' : '')"
                                placeholder="Enter status here"
                            />

                            <p class="text-sm text-gray-600 pt-2">
                                Enter a custom status
                            </p>
                        </div>
                        <div :class="'w-full mb-3'">
                            <p class="mb-1 text-xs mb-2"><strong>Status Color</strong></p>
                            <input v-model="new_status_color" class="rg-text-field block appearance-none focus:outline-none focus:border-gray-500 w-full bg-white hover:border-grey px-2 py-2 rounded" style="padding-right: 35px !important; width: 100px;"
                                :class="(($vuetify.breakpoint.xs) ? 'mb-2' : '')"
                                type="color"
                                placeholder="#000000"
                            />

                            <p class="text-sm text-gray-600 pt-2">
                                Specify a custom color for this status
                            </p>
                        </div>
                    </div>

                    </div>

                    <div class="bg-gray-100 rounded-b-lg px-6 py-4">

                    <button class="rg-dialog-button-save rounded text-white text-xs text-bold focus:outline-none py-2 px-4 float-right" :class="{'spinner': savingStatus}" @click="saveStatus">
                        Save
                    </button>

                    <button class="rounded text-blue text-xs text-bold border border-blue focus:outline-none py-2 px-4 mr-2 float-right" @click="showAddStatus = false">
                        CLOSE
                    </button>

                    <div class="clearfix"></div>

                    </div>

                </div>
            </div>

            <div v-if="shouldShowChatConversation" @click.self="shouldShowChatConversation = false" class="fixed top-0 left-0 h-full w-full z-50 flex flex-column items-center justify-center" style="background-color: rgba(0,0,0,.2);">
                <div class="w-full sm:w-1/3 lg:w-1/3 bg-white rounded-lg mx-6" style="max-height: 100%;">

                    <div class="p-6" style="position: relative; height: calc(100% - 20px); overflow: auto;">

                    <div class="float-right -mb-4" style="position: relative;">
                        <!-- <a href="https://www.bland.ai/" class="text-xs" target="lsa-bland-link">Sign Up for Bland</a> -->
                    </div>

                    <div style="clear: both;"></div>

                    <div>
                        <div v-if="loading_chat_conversation" :class="'w-full mb-3'">
                            <v-skeleton-loader type="article, article, article"></v-skeleton-loader>
                        </div>
                        <div class="flex flex-row flex-wrap" v-else>
                            <div class="w-full">
                                <div id="chat-dialog-messages-list" style="max-height: 500px; overflow: auto;">
                                    <div>
                                        <b-list-group>
                                            <b-list-group-item

                                                v-for="(item, index) in bland_transcription.messages" :key="index"
                                        
                                                    class="d-flex align-items-center mb-4 pb-4"
                                                    style="border: none; border-bottom: solid 1px #ededed;"
                                            >
                                                <b-avatar v-if="item.role == 'assistant' || !item.role"
                                                        text="S1"
                                                        class="mr-3 call-info-avatar"
                                                ></b-avatar>
                                                <b-avatar v-if="item.role == 'user'"
                                                        text="S2"
                                                        class="mr-3 call-info-avatar"
                                                ></b-avatar>
                                                <div>
                                                    <span v-if="!item.role" class="mr-auto primary-color text-bold">{{ me.first_name }} {{ me.last_name }}</span>
                                                    <span v-else>
                                                        <span v-if="item.role == 'assistant'" class="mr-auto primary-color text-bold">AI Agent</span>
                                                        <span v-else class="mr-auto warning-color text-bold">Customer</span>
                                                    </span>

                                                    <span class="mr-auto text-xs text-gray-600"> . {{ displayTimestamp(item.timestamp) }} . </span>
                                                    <div class="text-sm">{{ item.content }} <ReinforcementLearning v-if="item.role == 'assistant'" :message="item.content" /></div>
                                                </div>
                                            </b-list-group-item>
                                        </b-list-group>
                                    </div>
                                </div>

                                <div class="mt-4 -mb-12">
                                    <v-text-field
                                        clearable
                                        outlined
                                        dense
                                        hide-details
                                        label="Reply"
                                        v-model="new_ai_message"

                                        class="white border border-white"
                                    ></v-text-field>
                                </div>
                            </div>
                        </div>
                    </div>

                    </div>

                    <div class="bg-gray-100 rounded-b-lg px-6 py-4">

                        <button class="rounded text-blue text-xs text-bold border border-blue focus:outline-none py-2 px-4 mr-2 float-right" @click="shouldShowChatConversation = false">
                            CLOSE
                        </button>

                        <button
                                class="rg-dialog-button-save custom-button rounded bg-gray-500 hover:bg-gray-600 text-white focus:outline-none py-2 px-4 float-left"
                                :class="{ spinner: sendingAiMessage }"
                                @click="sendAiReply()"
                                :disabled="!new_ai_message"
                        >
                            SEND
                        </button>

                        <div style="float: right; padding-right: 30px; padding-top: 6px;">
                            <v-switch color="#48bb78" inset dense hide-details :ripple="false" v-model="ai_messages_lead.ai_enabled" label="AI Response Enabled" @change="switchAiResponseEnabled(ai_messages_lead);"></v-switch>
                        </div>

                        <div class="clearfix"></div>

                    <div class="clearfix"></div>

                    </div>

                </div>
            </div>

            <!-- <div class="float-right pt-3">
                <div class="border-1 border-purple bg-purple text-white text-xs text-bold px-4 py-2 rounded cursor-pointer float-right ml-2"
                     style="margin-top: -5px;" @click="downloadCsv()">

                    <i class="fa fa-spin fa-spinner mr-2" v-if="exporting"></i> Export
                </div>
            </div> -->

            <div class="rg-top-filter pt-1 float-right mr-2">
                <v-text-field
                    :value="formatDate(date_filter[0], 'MMM DD, YYYY') + '   -   ' + ((date_filter[1]) ? formatDate(date_filter[1], 'MMM DD, YYYY') : '')"
                    append-icon="mdi-calendar-blank-outline"
                    readonly
                    outlined
                    dense
                    style="width: 230px; background: #4EC5A1; color: #FFFFFF !important; border: 0px !important;"
                    hide-details
                    placholder="Choose Date"
                    @click="show_picker = !show_picker"
                ></v-text-field>
                
                <div v-if="show_picker" style="position: absolute; width: 490px; z-index: 999; margin-left: -260px; background: #FFFFFF; padding: 10px; margin-top: 5px; border-radius: 10px; box-shadow: 0px 0px 30px 0px #E2E2E2;">
                    <div style="float: left; border-right: solid 1px #d5d5d5;">
                    <div class="mb-2"><strong class="text-sm">Filter by Date</strong></div>

                    <v-date-picker
                    v-model="date_filter"
                    range
                    no-title
                    scrollable
                    @input="menu = false"
                    style="border: 0px;"
                    >
                    <v-spacer></v-spacer>
                        <v-btn
                            text
                            color="#44468F"
                            @click="show_picker = false"
                        >
                            Cancel
                        </v-btn>
                        <v-btn
                            text
                            color="#44468F"
                            @click="filterDate();"
                        >
                            UPDATE
                        </v-btn>
                    </v-date-picker>
                    </div>

                    <div style="float: left; margin-left: 20px; padding-left: 20px; padding-top: 20px;">
                    <div class="mb-2"><a href="javascript: void(0);" @click="applyDate('This Week')" :style="((selected_date_text == 'This Week') ? 'font-size: 14px; font-weight: bold;' : 'color: #696969 !important; font-size: 14px;')">This Week</a></div>
                    <div class="mb-2"><a href="javascript: void(0);" @click="applyDate('Last Week')" :style="((selected_date_text == 'Last Week') ? 'font-size: 14px; font-weight: bold;' : 'color: #696969 !important; font-size: 14px;')">Last Week</a></div>
                    <div class="mb-2"><a href="javascript: void(0);" @click="applyDate('This Month')" :style="((selected_date_text == 'This Month') ? 'font-size: 14px; font-weight: bold;' : 'color: #696969 !important; font-size: 14px;')">This Month</a></div>
                    <div class="mb-2"><a href="javascript: void(0);" @click="applyDate('Last Month')" :style="((selected_date_text == 'Last Month') ? 'font-size: 14px; font-weight: bold;' : 'color: #696969 !important; font-size: 14px;')">Last Month</a></div>
                    <div class="mb-2"><a href="javascript: void(0);" @click="applyDate('Last 60 days')" :style="((selected_date_text == 'Last 60 days') ? 'font-size: 14px; font-weight: bold;' : 'color: #696969 !important; font-size: 14px;')">Last 60 days</a></div>
                    <div class="mb-2"><a href="javascript: void(0);" @click="applyDate('Last 90 days')" :style="((selected_date_text == 'Last 90 days') ? 'font-size: 14px; font-weight: bold;' : 'color: #696969 !important; font-size: 14px;')">Last 90 days</a></div>
                    <div class="mb-2"><a href="javascript: void(0);" @click="applyDate('This Year')" :style="((selected_date_text == 'This Year') ? 'font-size: 14px; font-weight: bold;' : 'color: #696969 !important; font-size: 14px;')">This Year</a></div>
                    <div class="mb-2"><a href="javascript: void(0);" @click="applyDate('Last Year')" :style="((selected_date_text == 'Last Year') ? 'font-size: 14px; font-weight: bold;' : 'color: #696969 !important; font-size: 14px;')">Last Year</a></div>
                    <div class="mb-2"><a href="javascript: void(0);" @click="applyDate('All Time')" :style="((selected_date_text == 'All Time') ? 'font-size: 14px; font-weight: bold;' : 'color: #696969 !important; font-size: 14px;')">All Time</a></div>
                    </div>

                    <div style="clear: both;"></div>
                </div>
            </div>

            <div v-if="me && me.brightlocal_report_url" class="rg-top-filter pt-2 pr-2 float-right mr-5 text-sm">
                Local SEO Report: <a :href="me.brightlocal_report_url"">Click Here</a>
            </div>

            <div class="rg-top-filter pt-2 pr-2 float-right mr-5 text-xs -mt-5">
                <div class="grid grid-cols-3 gap-4 bg-gray-50 pl-2 pr-2 pt-1 pb-1 rounded-xl shadow-md w-full max-w-xl" style="background: #FFFFFF;">
                
                <!-- Qualified Leads -->
                <div class="text-center">
                    <div class="text-xs text-gray-500 flex justify-center items-center gap-1">
                    <i class="mdi mdi-account-search text-blue-500 text-lg"></i>
                    Qualified Leads
                    </div>
                    <div class="text-md font-bold text-blue-600">
                    {{ qualified_leads }}
                    </div>
                </div>

                <!-- Signed Leads -->
                <div class="text-center">
                    <div class="text-xs text-gray-500 flex justify-center items-center gap-1">
                    <i class="mdi mdi-account-check text-green-500 text-lg"></i>
                    Signed Leads
                    </div>
                    <div class="text-md font-bold text-green-600">
                    {{ converted_ai_leads_count }}
                    </div>
                </div>

                <!-- ROI -->
                <div class="text-center">
                    <div class="text-xs text-gray-500 flex justify-center items-center gap-1">
                    <i class="mdi mdi-cash-check" :class="[roiColorClass, 'text-lg']"></i>
                    ROI
                    </div>
                    <div class="text-md font-bold" :class="roiColorClass">
                    {{ roi }}
                    </div>
                </div>

                </div>
            </div>

            <h1 class="text-lg font-semibold mb-3"><span v-if="isSeoTab()">Local SEO</span><span v-else>Leads</span>
                <v-chip
                        class="ma-2"
                        color="#44468F"
                        outlined
                        small
                >
                    {{ messages.length }}
                </v-chip>
            </h1>
            <hr class="border-b border-gray-100 mb-3">

            <template>
                <v-row class="my-3 rg-top-filter-black-text">
                    <v-col cols="12" md="3" sm="3" xs="6">
                        <v-text-field
                                clearable
                                outlined
                                dense
                                hide-details
                                prepend-inner-icon="mdi-magnify"
                                label="Search"
                                v-model="search"

                                class="white border border-white"
                        ></v-text-field>
                    </v-col>
                    <template>
                        <v-col cols="12" md="3" sm="3" xs="6">
                            <v-select
                                    outlined
                                    dense
                                    hide-details
                                    label="Tags"
                                    class="white header-inputs"
                                    :item-text="item => item.text"
                                    :item-value="item => item.index"
                                    :items="tags_items"
                                    v-model="tag"
                                    clearable
                            ></v-select>
                        </v-col>
                        <v-spacer></v-spacer>
                         <v-col cols="12" md="3" sm="3" xs="6">
                            <v-select
                                    outlined
                                    dense
                                    hide-details
                                    label="Archived"
                                    class="white header-inputs"
                                    :items="['Show All', 'Show Unarchived', 'Show Archived']"
                                    v-model="archived_filter"
                                    clearable
                            ></v-select>
                        </v-col>
                        <v-spacer></v-spacer>
                        <v-col cols="12" md="3" sm="3" xs="6">
                            <div class="float-left" style="width: calc(100% - 85px);">
                                <v-select
                                        clearable
                                        outlined
                                        dense
                                        hide-details
                                        label="Status"
                                        :item-text="item => item.text"
                                        :item-value="item => item.index"
                                        class="white header-inputs"
                                        :items="qualify_status_items"
                                        v-model="qualify_status"
                                        clearable
                                ></v-select>
                            </div>

                            <div class="border-1 border-purple bg-purple text-white text-xs text-bold px-4 rounded cursor-pointer float-right ml-2" style="padding-bottom: 11px; padding-top: 11px;"
                                @click="getMessages();"
                            >
                                Filter
                            </div>
                        </v-col>
                    </template>
                </v-row>
            </template>
            <template>
                <div class="dashboard-box">
                    <v-card class="pa-2" tile>
                        <v-skeleton-loader v-if="loading" type="article, article, article"></v-skeleton-loader>

                        <div v-else class="p-3">
                            <div v-if="messages.length == 0">
                                <br/><br/><br/><br/>
                                <div class="dashboard-box-iconsquare">
                                    <div class="dashboard-box-icon-background"></div>
                                    <div class="dashboard-box-icon">
                                        <i class="mdi mdi-phone"></i>
                                    </div>
                                </div>
                                <div style="text-align: center;">
                                    <div class="pt-2 pb-2">
                                        <strong>No Leads</strong>
                                    </div>

                                    <div class="text-sm mb-4 text-gray-600">
                                        No leads found for the given period. Refine your search or wait until new leads come in.
                                    </div>
                                    <br/>
                                </div>
                                <br/><br/><br/><br/><br/>
                            </div>

                            <div v-else style="clear: both; padding-top: 0px;">

                                <div style="float: right; font-size: 12px; line-height: 20px; margin-top: -5px; text-align: right;">
                                    <div class="stats-btn" style="padding: 6px; border: solid 1px #CCCCCC; border-radius: 5px; background: #FFFFFF; padding-left: 10px; padding-right: 10px;">
                                        Stats

                                        <div  class="stats-div" style="padding: 6px;border: 1px solid rgb(204, 204, 204);border-radius: 5px;background: rgb(255, 255, 255);position: absolute;width: 200px;margin-left: -158px;z-index: 3;">
                                            <div style="">Total: <strong>{{ messages.length }}</strong></div>
                                            <div style="padding-top: 15px;">AI: <strong>{{ ai_leads_count }}</strong> (<i class="mdi mdi-message-outline"></i> {{ ai_leads_count_msg }} | <i class="mdi mdi-phone"></i> {{ ai_leads_count_voice }} )</div>
                                            <div style="">LSA: <strong>{{ lsa_leads_count }}</strong></div>
                                            <div style="">CallRail: <strong>{{ callrail_leads_count }}</strong></div>

                                            <div style="padding-top: 15px;">Converted: <strong>{{ converted_leads_count }}</strong> ({{ ((messages.length == 0) ? '0' : (parseInt((converted_leads_count/messages.length) * 100))) }}%)</div>
                                            <div style="">Booked: <strong>{{ booked_leads_count }}</strong> ({{ ((messages.length == 0) ? '0' : (parseInt((booked_leads_count/messages.length) * 100))) }}%)</div>
                                            <div style="padding-top: 15px;">Converted AI: <strong>{{ converted_ai_leads_count }}</strong> ({{ ((converted_leads_count == 0) ? '0' : (parseInt((converted_ai_leads_count/converted_leads_count) * 100))) }}%)</div>
                                            <div style="">Converted Human: <strong>{{ converted_human_leads_count }}</strong> ({{ ((converted_leads_count == 0) ? '0' : (parseInt((converted_human_leads_count/converted_leads_count) * 100))) }}%)</div>
                                            <div style="">Booked AI: <strong>{{ booked_ai_leads_count }}</strong> ({{ ((booked_leads_count == 0) ? '0' : (parseInt((booked_ai_leads_count/booked_leads_count) * 100))) }}%)</div>
                                            <div style="">Booked Human: <strong>{{ booked_human_leads_count }}</strong> ({{ ((booked_leads_count == 0) ? '0' : (parseInt((booked_human_leads_count/booked_leads_count) * 100))) }}%)</div>
                                        </div>
                                    </div>
                                </div>

                                <div style="float: left;">
                                    <button v-show="selectedIds.length > 0" class="rg-dialog-button-save rounded text-white text-xs text-bold focus:outline-none py-2 px-4" @click="show_analysis_dialog = true">
                                        <i class="mdi mdi-play-outline" style="font-size: 16px;"></i> Run Analysis
                                    </button>

                                    <button v-if="me && me.request_reviews_access" v-show="selectedPhoneNumbers.length > 0" class="rg-dialog-button-save rounded text-white text-xs text-bold focus:outline-none py-2 px-4 ml-3" @click="$refs.dialogRequestReview.show(); $refs.dialogRequestReview.setPhoneNumbers(selectedPhoneNumbers); selected = []; selectedIds = [];">
                                        <i class="mdi mdi-star" style="font-size: 16px;"></i> Request Review
                                    </button>
                                </div>

                                <div style="clear: both; padding-bottom: 10px;"></div>

                                <v-data-table
                                v-if="me"
                                :headers="((me.email == 'sue@chiefmarketingoutsider.com') ? headers_custom_comfort : ((isOnlyAi()) ? diy_headers : headers))"
                                :items="messages"
                                :items-per-page="20"
                                class="rg-datatable elevation-1"
                                :footer-props="{
                                itemsPerPageOptions: [10, 20, 30, 40, 50, 100],
                                showFirstLastPage: true
                                }"
                                mobile-breakpoint="10"
                                show-select
                                v-model="selected"
                                item-key="id"
                                >
                                
                                    <template v-slot:item.customer_phone_number="{ item }">
                                        <span :style="((item.archived == 1) ? 'text-decoration: line-through;' : '')"><a href="javascript: void(0);" @click="filterBy(item.customer_phone_number)">{{ item.customer_phone_number }}</a></span>
                                    </template>
                                
                                    <template v-slot:item.to="{ item }">
                                        {{ item.to || "-" }}
                                    </template>

                                    <template v-slot:item.lead_type="{ item }">
                                        <!-- <span v-if="item.sources.indexOf('web') != -1">
                                            Chat
                                        </span>
                                        <span v-else> -->
                                            <span v-if="item.lead_type == 'PHONE_CALL'">
                                                Voice
                                            </span>

                                            <span v-if="item.lead_type == 'MESSAGE'">
                                                Message
                                            </span>

                                            <span v-if="item.lead_type == 'BOOKING'">
                                                Booking
                                            </span>
                                        <!-- </span> -->
                                    </template>

                                    <template v-slot:item.lead_category="{ item }">
                                        <span v-if="item.lead_category">
                                            {{ item.lead_category.replace(/\_/g, " ") }}
                                        </span>

                                        <span v-if="!item.lead_category">
                                            N/A
                                        </span>
                                    </template>

                                    <template v-slot:item.sources="{ item }">
                                        <span v-if="item.sources.indexOf('lsa') != -1">
                                            <v-tooltip top color="primary">
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <div v-if="item.lead_type == 'PHONE_CALL'" style="float: left; margin-right: 5px; padding-top: 4px; cursor: pointer;" @click="showLsaCallRecordings(item);"
                                                        :style="((me && me.is_medical) ? 'cursor: initial;' : '')"
                                                        >
                                                            <img :src="require('@/assets/images/lsa.webp')"
                                                                v-bind="attrs"
                                                                v-on="on" style="width: 26px;" />
                                                        </div>
                                                        <div v-if="item.lead_type == 'MESSAGE'" style="float: left; margin-right: 5px; padding-top: 4px; cursor: pointer;" @click="showLsaMessagesFunction(item);"
                                                            :style="((me && me.is_medical) ? 'cursor: initial;' : '')"
                                                        >
                                                            <img :src="require('@/assets/images/lsa.webp')"
                                                                v-bind="attrs"
                                                                v-on="on" style="width: 26px;" />
                                                        </div>
                                                    </template>
                                                    <span>LSA</span>
                                            </v-tooltip>
                                        </span>

                                        <span v-if="item.sources.indexOf('callrail') != -1">
                                            <v-tooltip top color="primary">
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <div style="float: left; margin-right: 5px; padding-top: 4px; cursor: pointer;" @click="showCallRailRecordingFunction(item);"
                                                            :style="((me && me.is_medical) ? 'cursor: initial;' : '')"
                                                        >
                                                            <img :src="require('@/assets/images/callrail.png')"
                                                                v-bind="attrs"
                                                                v-on="on" style="width: 22px;" />
                                                        </div>
                                                    </template>
                                                    <span>CallRail</span>
                                            </v-tooltip>
                                        </span>

                                        <span v-if="item.sources.indexOf('bland') != -1">
                                            <v-tooltip bottom color="primary">
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <div :id="'sblrcfncc-' + item.id" style="float: left; margin-right: 5px; padding-top: 4px; cursor: pointer;" @click="showBlandRecordingFunction(item);"
                                                            :style="((me && me.is_medical) ? 'cursor: initial;' : '')"
                                                        >
                                                            <img :src="require('@/assets/images/bland.png')"
                                                                v-bind="attrs"
                                                                v-on="on" style="width: 22px;" />
                                                        </div>
                                                    </template>

                                                    <span v-if="item.lead_type == 'MESSAGE'">AI</span>
                                                    <span v-else>
                                                        <span>Details:</span>

                                                        <br /><br />
                                                        <strong>Customer's name:</strong> {{ item.customer_name || "-" }}
                                                        <br />
                                                        <strong>Customer's email:</strong> {{ item.customer_email || "-" }}
                                                        <br />
                                                        <strong>Customer's phone:</strong> {{ item.ai_provided_phone_number || "-" }}
                                                        <br />
                                                        <strong>Service needed:</strong> {{ item.job_type || "-" }}
                                                        <br /><br />
                                                        <strong>Call ended by:</strong> {{ item.call_ended_by || "-" }}
                                                    </span>
                                            </v-tooltip>
                                        </span>

                                        <span v-if="item.sources.indexOf('web') != -1">
                                            <v-tooltip top color="primary">
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <div style="float: left; margin-right: 5px; padding-top: 4px; cursor: pointer;" @click="showChatConversation(item);"
                                                            :style="((me && me.is_medical) ? 'cursor: initial;' : '')"
                                                        >
                                                            <img :src="require('@/assets/images/web.png')"
                                                                v-bind="attrs"
                                                                v-on="on" style="height: 22px; border: solid 1px #dddddd;" />
                                                        </div>
                                                    </template>
                                                    <span>Web</span>
                                            </v-tooltip>
                                        </span>
                                    </template>

                                    <template v-slot:item.ai_feedback="{ item }">
                                        <div style="position: relative;">
                                            <a href="javascript: void(0);" @click="item.show_ai_feedback = !item.show_ai_feedback || true;">
                                                <span v-if="item.ai_feedback_urgent">🚨</span>
                                                <strong v-if="item.ai_feedback">View</strong><span v-else="">Edit</span>
                                            </a>

                                            <div v-show="item.show_ai_feedback" style="position: absolute; background: #FFFFFF; padding: 10px; border: solid 1px #CCCCCC; width: 250px; z-index: 1;">
                                                <textarea v-model="item.ai_feedback" style="padding: 10px; width: 100%; height: 200px; border: solid 1px #CCCCCC; border-radius: 5px;"></textarea>

                                                <br />

                                                <v-switch color="#48bb78" inset dense hide-details :ripple="false" v-model="item.ai_feedback_urgent" label="Urgent"></v-switch>

                                                <br />

                                                <button class="rg-dialog-button-save rounded text-white text-xs text-bold focus:outline-none py-2 px-4 w-full mb-2" :class="{'spinner': savingAiFeedback}" @click="saveAiFeedback(item)">
                                                    Save
                                                </button>

                                                <button class="rounded custom-bordered-button hover:bg-gray-200 text-gray-800 border border-gray-800 focus:outline-none py-2 px-4 w-full mb-2" :class="{'spinner': savingAiFeedback}" @click="item.ai_feedback = ''; item.ai_feedback_urgent = 0; saveAiFeedback(item)">
                                                    CLEAR
                                                </button>
                                            </div>
                                        </div>
                                    </template>

                                    <template v-slot:item.lead_creation_date="{ item }">
                                        {{ displayTimestamp(item.lead_creation_date) }}
                                    </template>

                                    <template v-slot:item.updated_at="{ item }">
                                        {{ displayTimestamp(item.updated_at) }}
                                    </template>

                                    <template v-slot:item.responded_time="{ item }">
                                        <span v-if="item.responded_time !== NULL && item.responded_time !== -1">
                                            <span v-if="item.responded_time > 1000">
                                                {{ parseInt(item.responded_time / 60) }} minutes
                                            </span>
                                            <span v-else>
                                                {{ item.responded_time }} seconds
                                            </span>
                                        </span>
                                        <span v-else>N/A</span>
                                    </template>
                                    
                                    <template v-slot:item.geo="{ item }">
                                        <span v-if="item.geo">
                                            {{ item.geo.split(',')[0] }}
                                        </span>
                                        <span v-else>
                                            N/A
                                        </span>
                                    </template>

                                    <template v-slot:item.job_type="{ item }">
                                        <span v-if="item.job_type">
                                            {{ item.job_type.replace(/\_/g, " ").toLowerCase().replace(/\b[a-z]/g, function(letter) { return letter.toUpperCase(); }) }}
                                        </span>
                                        <span v-else>
                                            N/A
                                        </span>
                                    </template>

                                    <template v-slot:item.call_status="{ item }">
                                        <span v-if="item.call_status == 'in-progress'">
                                            <i class="fa fa-spin fa-spinner"></i>
                                        </span>
                                        <span v-else>
                                            {{ item.call_status }}
                                        </span>
                                    </template>

                                    <template v-slot:item.from="{ item }">
                                        {{ formatPhoneNumber(item.from) }}
                                    </template>

                                    <template v-slot:item.recording_url="{ item }">
                                        <div v-if="item.recording_url">
                                            <i class="audio-element-icon fa fa-play" :id="'audio-element-icon-' + item.id" style="cursor: pointer;" @click="playAudio(item);"></i>

                                            <div class="audio-element-wrapper" :id="'audio-element-wrapper-' + item.id" style="position: absolute; z-index: 99; margin-left: -10px; display: none !important; margin-top: -20px;">
                                                <i class="mdi mdi-close-circle" style="position: absolute; right: 0px; top: -10px; font-size: 20px; z-index: 99; cursor: pointer;" @click="playAudio(item)"></i>
                                                <audio class="audio-element" :id="'audio-element-' + item.id" controls="play, pause, volume" style="height: 38px;">
                                                    <source :src="item.recording_url" type="audio/mpeg">
                                                </audio>
                                            </div>
                                        </div>
                                        <div v-else>
                                            -
                                        </div>
                                    </template>

                                    <template v-slot:item.customer_name="{ item }">
                                        <div :class="'lsa-show-customer-name lsa-show-customer-name-' + item.id">
                                            <a href="javascript: void(0);" @click="showEditCustomerName(item)">{{ item.customer_name }}<i v-show="$store.state.auth.owner" class="mdi mdi-pencil-outline ml-2"></i></a>
                                        </div>
                                        <div :class="'lsa-edit-customer-name lsa-edit-customer-name-' + item.id" style="display: none; position: relative;">
                                            <input type="text" :value="item.customer_name" style="padding: 5px; border: solid 1px #CCCCCC; width: 100px;" />
                                            <div style="position: absolute; margin-top: -22px; right: -31px;">
                                                <a href="javascript: void(0);" style="color: #3EBB80 !important;" @click="editCustomerName(item)"><i class="mdi mdi-check"></i></a>
                                                <a href="javascript: void(0);" class="" style="color: #E53F71 !important;" @click="cancelEditCustomerName(item)"><i class="mdi mdi-close"></i></a>
                                            </div>
                                            <div style="clear: both;"></div>
                                        </div>
                                    </template>

                                    <template v-slot:item.address="{ item }">
                                        <div :class="'lsa-show-address lsa-show-address-' + item.id">
                                            <a href="javascript: void(0);" @click="showEditAddress(item)">{{ item.address }}<i v-show="$store.state.auth.owner" class="mdi mdi-pencil-outline ml-2"></i></a>
                                        </div>
                                        <div :class="'lsa-edit-address lsa-edit-address-' + item.id" style="display: none; position: relative;">
                                            <input type="text" :value="item.address" style="padding: 5px; border: solid 1px #CCCCCC; width: 100px;" />
                                            <div style="position: absolute; margin-top: -22px; right: -31px;">
                                                <a href="javascript: void(0);" style="color: #3EBB80 !important;" @click="editAddress(item)"><i class="mdi mdi-check"></i></a>
                                                <a href="javascript: void(0);" class="" style="color: #E53F71 !important;" @click="cancelEditAddress(item)"><i class="mdi mdi-close"></i></a>
                                            </div>
                                            <div style="clear: both;"></div>
                                        </div>
                                    </template>

                                    <template v-slot:item.value="{ item }">
                                        <div :class="'lsa-show-value lsa-show-value-' + item.id">
                                            <a href="javascript: void(0);" @click="showEditValue(item)">${{ item.value }}<i v-show="$store.state.auth.owner" class="mdi mdi-pencil-outline ml-2"></i></a>
                                        </div>
                                        <div :class="'lsa-edit-value lsa-edit-value-' + item.id" style="display: none; position: relative;">
                                            <input type="text" :value="((item.value > 0) ? item.value : me.settings.customer_value)" style="padding: 5px; border: solid 1px #CCCCCC; width: 100px;" />
                                            <div style="position: absolute; margin-top: -22px; right: -31px;">
                                                <a href="javascript: void(0);" style="color: #3EBB80 !important;" @click="editValue(item)"><i class="mdi mdi-check"></i></a>
                                                <a href="javascript: void(0);" class="" style="color: #E53F71 !important;" @click="cancelEditValue(item)"><i class="mdi mdi-close"></i></a>
                                            </div>
                                            <div style="clear: both;"></div>
                                        </div>
                                    </template>

                                    <template v-slot:item.tag="{ item }">
                                        <div class="pt-2 pb-2">
                                            <span v-for="(tag, index_tag) in item.tag" :key="'tag-' + index_tag" class="pr-2 pb-2">
                                                <v-chip v-if="tag == 0" class="mb-1 dark">
                                                    <span style="font-size: 12px;">Not Set</span>
                                                </v-chip>

                                                <v-chip class="mb-1" v-if="tag == 1" color="#3EBB80">
                                                    <span style="font-size: 12px; color: #FFFFFF;">Existing Customer</span>

                                                    <v-icon v-show="$store.state.auth.owner" class="tags" style="color: #FFFFFF; cursor: pointer;" @click="removeTag(item, tag);">mdi-delete-outline</v-icon>
                                                </v-chip>

                                                <v-chip class="mb-1" v-if="tag == 2" color="#44468F">
                                                    <span style="font-size: 12px; color: #FFFFFF;">Missed Call</span>

                                                    <v-icon v-show="$store.state.auth.owner" class="tags" style="color: #FFFFFF; cursor: pointer;" @click="removeTag(item, tag);">mdi-delete-outline</v-icon>
                                                </v-chip>

                                                <v-chip class="mb-1" v-if="tag == 3" color="#FFB443" v-show="!isOnlyAi()">
                                                    <span style="font-size: 12px; color: #FFFFFF;">Opportunity</span>

                                                    <v-icon v-show="$store.state.auth.owner" class="tags" style="color: #FFFFFF; cursor: pointer;" @click="removeTag(item, tag);">mdi-delete-outline</v-icon>
                                                </v-chip>

                                                <v-chip class="mb-1" v-if="tag == 4" color="#2477F6" v-show="!isOnlyAi()">
                                                    <span style="font-size: 12px; color: #FFFFFF;">Meeting Scheduled</span>

                                                    <v-icon v-show="$store.state.auth.owner" class="tags" style="color: #FFFFFF; cursor: pointer;" @click="removeTag(item, tag);">mdi-delete-outline</v-icon>
                                                </v-chip>

                                                <v-chip class="mb-1" v-if="tag == 5" color="#E53F71">
                                                    <span style="font-size: 12px; color: #FFFFFF;">Became Customer</span>

                                                    <v-icon v-show="$store.state.auth.owner" class="tags" style="color: #FFFFFF; cursor: pointer;" @click="removeTag(item, tag);">mdi-delete-outline</v-icon>
                                                </v-chip>

                                                <v-chip class="mb-1" v-if="tag == 'Signed'" color="#2137cb" v-show="!isOnlyAi()">
                                                    <span style="font-size: 12px; color: #FFFFFF;">Signed</span>

                                                    <v-icon v-show="$store.state.auth.owner" class="tags" style="color: #FFFFFF; cursor: pointer;" @click="removeTag(item, tag);">mdi-delete-outline</v-icon>
                                                </v-chip>

                                                <v-chip class="mb-1" v-if="tag == 'Booked for Consultation'" color="#2bce7f" v-show="!isOnlyAi()">
                                                    <span style="font-size: 12px; color: #FFFFFF;">Booked for Consultation</span>

                                                    <v-icon v-show="$store.state.auth.owner" class="tags" style="color: #FFFFFF; cursor: pointer;" @click="removeTag(item, tag);">mdi-delete-outline</v-icon>
                                                </v-chip>

                                                <v-chip class="mb-1" v-if="tag == 'Declined/Not a lead'" color="#aa242b" v-show="!isOnlyAi()">
                                                    <span style="font-size: 12px; color: #FFFFFF;">Declined/Not a lead</span>

                                                    <v-icon v-show="$store.state.auth.owner" class="tags" style="color: #FFFFFF; cursor: pointer;" @click="removeTag(item, tag);">mdi-delete-outline</v-icon>
                                                </v-chip>

                                                <v-chip class="mb-1" v-if="tag == 'Wrong Number'" color="#de2f4d" v-show="!isOnlyAi()">
                                                    <span style="font-size: 12px; color: #FFFFFF;">Wrong Number</span>

                                                    <v-icon v-show="$store.state.auth.owner" class="tags" style="color: #FFFFFF; cursor: pointer;" @click="removeTag(item, tag);">mdi-delete-outline</v-icon>
                                                </v-chip>

                                                <v-chip class="mb-1" v-if="tag == 'No Response'" color="#3f3f3f" v-show="!isOnlyAi()">
                                                    <span style="font-size: 12px; color: #FFFFFF;">No Response</span>

                                                    <v-icon v-show="$store.state.auth.owner" class="tags" style="color: #FFFFFF; cursor: pointer;" @click="removeTag(item, tag);">mdi-delete-outline</v-icon>
                                                </v-chip>

                                                <v-chip class="mb-1" v-if="tag == 'Existing Client'" color="#4ad25a" v-show="!isOnlyAi()">
                                                    <span style="font-size: 12px; color: #FFFFFF;">Existing Client</span>

                                                    <v-icon v-show="$store.state.auth.owner" class="tags" style="color: #FFFFFF; cursor: pointer;" @click="removeTag(item, tag);">mdi-delete-outline</v-icon>
                                                </v-chip>

                                                <v-chip class="mb-1" v-if="tag == 'Failed Sign Up'" color="#830934" v-show="!isOnlyAi()">
                                                    <span style="font-size: 12px; color: #FFFFFF;">Failed Sign Up</span>

                                                    <v-icon v-show="$store.state.auth.owner" class="tags" style="color: #FFFFFF; cursor: pointer;" @click="removeTag(item, tag);">mdi-delete-outline</v-icon>
                                                </v-chip>

                                                <v-chip class="mb-1" v-if="tag == 'Following Up/Working on this one'" color="#9418af" v-show="!isOnlyAi()">
                                                    <span style="font-size: 12px; color: #FFFFFF;">Following Up/Working on this one</span>

                                                    <v-icon v-show="$store.state.auth.owner" class="tags" style="color: #FFFFFF; cursor: pointer;" @click="removeTag(item, tag);">mdi-delete-outline</v-icon>
                                                </v-chip>

                                                <v-chip class="mb-1" v-if="tag == 'E-Doc sent not signed'" color="#5a3a69" v-show="!isOnlyAi()">
                                                    <span style="font-size: 12px; color: #FFFFFF;">E-Doc sent not signed</span>

                                                    <v-icon v-show="$store.state.auth.owner" class="tags" style="color: #FFFFFF; cursor: pointer;" @click="removeTag(item, tag);">mdi-delete-outline</v-icon>
                                                </v-chip>

                                                <v-chip class="mb-1" v-if="tag == 'Booked to Service'" color="#2bce7f" v-show="!isOnlyAi()">
                                                    <span style="font-size: 12px; color: #FFFFFF;">Booked to Service</span>

                                                    <v-icon v-show="$store.state.auth.owner" class="tags" style="color: #FFFFFF; cursor: pointer;" @click="removeTag(item, tag);">mdi-delete-outline</v-icon>
                                                </v-chip>

                                                <v-chip class="mb-1" v-if="tag == 'Booked for Appointment'" color="#1921ba" v-show="!isOnlyAi()">
                                                    <span style="font-size: 12px; color: #FFFFFF;">Booked for Appointment</span>

                                                    <v-icon v-show="$store.state.auth.owner" class="tags" style="color: #FFFFFF; cursor: pointer;" @click="removeTag(item, tag);">mdi-delete-outline</v-icon>
                                                </v-chip>

                                                <v-chip class="mb-1" v-if="tag == 'Cancelled'" color="#c6ab24">
                                                    <span style="font-size: 12px; color: #FFFFFF;">Cancelled</span>

                                                    <v-icon v-show="$store.state.auth.owner" class="tags" style="color: #FFFFFF; cursor: pointer;" @click="removeTag(item, tag);">mdi-delete-outline</v-icon>
                                                </v-chip>

                                                <v-chip class="mb-1" v-if="tag == 'Complete'" color="#1921ba">
                                                    <span style="font-size: 12px; color: #FFFFFF;">Complete</span>

                                                    <v-icon v-show="$store.state.auth.owner" class="tags" style="color: #FFFFFF; cursor: pointer;" @click="removeTag(item, tag);">mdi-delete-outline</v-icon>
                                                </v-chip>

                                                <v-chip class="mb-1" v-if="tag == 'Incomplete'" color="#c6ab24">
                                                    <span style="font-size: 12px; color: #FFFFFF;">Incomplete</span>

                                                    <v-icon v-show="$store.state.auth.owner" class="tags" style="color: #FFFFFF; cursor: pointer;" @click="removeTag(item, tag);">mdi-delete-outline</v-icon>
                                                </v-chip>

                                                <v-chip class="mb-1" v-if="tag == 'AI Test Call'" color="#000000">
                                                    <span style="font-size: 12px; color: #FFFFFF;">AI Test Call</span>

                                                    <v-icon v-show="$store.state.auth.owner" class="tags" style="color: #FFFFFF; cursor: pointer;" @click="removeTag(item, tag);">mdi-delete-outline</v-icon>
                                                </v-chip>

                                                <v-chip class="mb-1" v-if="tag == 'Duplicate Call'" color="#6750D7">
                                                    <span style="font-size: 12px; color: #FFFFFF;">Duplicate Call</span>

                                                    <v-icon v-show="$store.state.auth.owner" class="tags" style="color: #FFFFFF; cursor: pointer;" @click="removeTag(item, tag);">mdi-delete-outline</v-icon>
                                                </v-chip>

                                                <v-chip class="mb-1" v-if="tag != 0 && tag != 1 && tag != 2 && tag != 3 && tag != 4 && tag != 5
                                                    && tag != 'Signed'
                                                    && tag != 'Booked for Consultation'
                                                    && tag != 'Declined/Not a lead'
                                                    && tag != 'Wrong Number'
                                                    && tag != 'No Response'
                                                    && tag != 'Existing Client'
                                                    && tag != 'Failed Sign Up'
                                                    && tag != 'Following Up/Working on this one'
                                                    && tag != 'E-Doc sent not signed'
                                                    && tag != 'Booked to Service'
                                                    && tag != 'Booked for Appointment'
                                                    && tag != 'Cancelled'
                                                    && tag != 'Complete'
                                                    && tag != 'Incomplete'
                                                    && tag != 'AI Test Call'
                                                    && tag != 'Duplicate Call'
                                                
                                                " :color="getCustomTagColor(tag)">
                                                    <span style="font-size: 12px; color: #FFFFFF;">{{ tag }}</span>

                                                    <v-icon v-show="$store.state.auth.owner" class="tags" style="color: #FFFFFF; cursor: pointer;" @click="removeTag(item, tag);">mdi-delete-outline</v-icon>
                                                </v-chip>
                                            </span>
                                        </div>

                                        <v-menu
                                            
                                            

                                                bottom
                                                right

                                                nudge-bottom='25'
                                        >
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-icon v-show="$store.state.auth.owner" color="green" v-bind="attrs" v-on="on" :ripple="false" small class="ml-1">mdi-plus</v-icon>
                                            </template>

                                            <v-list class="table-menu-actions p-2" style="max-height: 500px; overflow-y: auto;">
                                                <v-list-item class="hover:bg-gray-200">
                                                    <v-list-item-title><a href="javascript: void(0);"><span
                                                        class="table-menu-action-icon" style="color: #44468F;" @click="setTag(item, 2);">Missed Call</span></a>
                                                    </v-list-item-title>
                                                </v-list-item>

                                                <v-list-item class="hover:bg-gray-200" v-show="!isOnlyAi()">
                                                    <v-list-item-title><a href="javascript: void(0);"><span
                                                        class="table-menu-action-icon" style="color: #FFB443;" @click="setTag(item, 3);">Opportunity</span></a>
                                                    </v-list-item-title>
                                                </v-list-item>

                                                <v-list-item class="hover:bg-gray-200" v-show="!isOnlyAi()">
                                                    <v-list-item-title><a href="javascript: void(0);"><span
                                                        class="table-menu-action-icon" style="color: #2477F6;" @click="setTag(item, 4);">Meeting Scheduled</span></a>
                                                    </v-list-item-title>
                                                </v-list-item>

                                                <v-list-item class="hover:bg-gray-200">
                                                    <v-list-item-title><a href="javascript: void(0);"><span
                                                        class="table-menu-action-icon" style="color: #E53F71;" @click="setTag(item, 5);">Became Customer</span></a>
                                                    </v-list-item-title>
                                                </v-list-item>

                                                <v-list-item class="hover:bg-gray-200" v-show="!isOnlyAi()">
                                                    <v-list-item-title><a href="javascript: void(0);"><span
                                                        class="table-menu-action-icon" style="color: #3EBB80;" @click="setTag(item, 1);">Existing Customer</span></a>
                                                    </v-list-item-title>
                                                </v-list-item>

                                                <v-list-item class="hover:bg-gray-200" v-show="!isOnlyAi()">
                                                    <v-list-item-title><a href="javascript: void(0);"><span
                                                        class="table-menu-action-icon" style="color: #2137cb;" @click="setTag(item, 'Signed');">Signed</span></a>
                                                    </v-list-item-title>
                                                </v-list-item>

                                                <v-list-item class="hover:bg-gray-200" v-show="!isOnlyAi()">
                                                    <v-list-item-title><a href="javascript: void(0);"><span
                                                        class="table-menu-action-icon" style="color: #2bce7f;" @click="setTag(item, 'Booked for Consultation');">Booked for Consultation</span></a>
                                                    </v-list-item-title>
                                                </v-list-item>

                                                <v-list-item class="hover:bg-gray-200" v-show="!isOnlyAi()">
                                                    <v-list-item-title><a href="javascript: void(0);"><span
                                                        class="table-menu-action-icon" style="color: #aa242b;" @click="setTag(item, 'Declined/Not a lead');">Declined/Not a lead</span></a>
                                                    </v-list-item-title>
                                                </v-list-item>

                                                <v-list-item class="hover:bg-gray-200" v-show="!isOnlyAi()">
                                                    <v-list-item-title><a href="javascript: void(0);"><span
                                                        class="table-menu-action-icon" style="color: #de2f4d;" @click="setTag(item, '>Wrong Number');">Wrong Number</span></a>
                                                    </v-list-item-title>
                                                </v-list-item>

                                                <v-list-item class="hover:bg-gray-200" v-show="!isOnlyAi()">
                                                    <v-list-item-title><a href="javascript: void(0);"><span
                                                        class="table-menu-action-icon" style="color: #3f3f3f;" @click="setTag(item, 'No Response');">No Response</span></a>
                                                    </v-list-item-title>
                                                </v-list-item>

                                                <v-list-item class="hover:bg-gray-200" v-show="!isOnlyAi()">
                                                    <v-list-item-title><a href="javascript: void(0);"><span
                                                        class="table-menu-action-icon" style="color: #4ad25a;" @click="setTag(item, 'Existing Client');">Existing Client</span></a>
                                                    </v-list-item-title>
                                                </v-list-item>

                                                <v-list-item class="hover:bg-gray-200" v-show="!isOnlyAi()">
                                                    <v-list-item-title><a href="javascript: void(0);"><span
                                                        class="table-menu-action-icon" style="color: #830934;" @click="setTag(item, 'Failed Sign Up');">Failed Sign Up</span></a>
                                                    </v-list-item-title>
                                                </v-list-item>

                                                <v-list-item class="hover:bg-gray-200" v-show="!isOnlyAi()">
                                                    <v-list-item-title><a href="javascript: void(0);"><span
                                                        class="table-menu-action-icon" style="color: #9418af;" @click="setTag(item, 'Following Up/Working on this one');">Following Up/Working on this one</span></a>
                                                    </v-list-item-title>
                                                </v-list-item>

                                                <v-list-item class="hover:bg-gray-200" v-show="!isOnlyAi()">
                                                    <v-list-item-title><a href="javascript: void(0);"><span
                                                        class="table-menu-action-icon" style="color: #5a3a69;" @click="setTag(item, 'E-Doc sent not signed');">E-Doc sent not signed</span></a>
                                                    </v-list-item-title>
                                                </v-list-item>

                                                <v-list-item class="hover:bg-gray-200" v-show="!isOnlyAi()">
                                                    <v-list-item-title><a href="javascript: void(0);"><span
                                                        class="table-menu-action-icon" style="color: #2bce7f;" @click="setTag(item, 'Booked to Service');">Booked to Service</span></a>
                                                    </v-list-item-title>
                                                </v-list-item>

                                                <v-list-item class="hover:bg-gray-200" v-show="!isOnlyAi()">
                                                    <v-list-item-title><a href="javascript: void(0);"><span
                                                        class="table-menu-action-icon" style="color: #1921ba;" @click="setTag(item, 'Booked for Appointment');">Booked for Appointment</span></a>
                                                    </v-list-item-title>
                                                </v-list-item>

                                                <v-list-item class="hover:bg-gray-200" v-show="!isOnlyAi()">
                                                    <v-list-item-title><a href="javascript: void(0);"><span
                                                        class="table-menu-action-icon" style="color: #c6ab24;" @click="setTag(item, 'Cancelled');">Cancelled</span></a>
                                                    </v-list-item-title>
                                                </v-list-item>

                                                <v-list-item class="hover:bg-gray-200">
                                                    <v-list-item-title><a href="javascript: void(0);"><span
                                                        class="table-menu-action-icon" style="color: #1921ba;" @click="setTag(item, 'Complete');">Complete</span></a>
                                                    </v-list-item-title>
                                                </v-list-item>

                                                <v-list-item class="hover:bg-gray-200">
                                                    <v-list-item-title><a href="javascript: void(0);"><span
                                                        class="table-menu-action-icon" style="color: #c6ab24;" @click="setTag(item, 'Incomplete');">Incomplete</span></a>
                                                    </v-list-item-title>
                                                </v-list-item>

                                                <v-list-item class="hover:bg-gray-200">
                                                    <v-list-item-title><a href="javascript: void(0);"><span
                                                        class="table-menu-action-icon" style="color: #000000;" @click="setTag(item, 'AI Test Call');">AI Test Call</span></a>
                                                    </v-list-item-title>
                                                </v-list-item>

                                                <v-list-item class="hover:bg-gray-200">
                                                    <v-list-item-title><a href="javascript: void(0);"><span
                                                        class="table-menu-action-icon" style="color: #6750D7;" @click="setTag(item, 'Duplicate Call');">Duplicate Call</span></a>
                                                    </v-list-item-title>
                                                </v-list-item>

                                                <v-list-item v-for="(custom_tag, tag_index) in custom_tags" :key="'custom-tag-' + tag_index" class="hover:bg-gray-200">
                                                    <v-list-item-title><a href="javascript: void(0);"><span
                                                        class="table-menu-action-icon" :style="'color: ' + custom_tag.color + ';'" @click="setTag(item, custom_tag.tag);">{{ custom_tag.tag }}</span></a>
                                                    </v-list-item-title>
                                                </v-list-item>

                                                <v-list-item class="hover:bg-gray-200">
                                                    <v-list-item-title><a href="javascript: void(0);" @click="showAddTag = true">+ Add Tag</a></v-list-item-title>
                                                </v-list-item>
                                            </v-list>
                                        </v-menu>
                                    </template>

                                    <template v-slot:item.qualify_status="{ item }">
                                        <v-chip
                                                small
                                                color="gray lighten-5"
                                                text-color="gray lighten-1"
                                            
                                                v-if="item.qualify_status == 0"
                                        >
                                            Not Set
                                        </v-chip>

                                        <v-chip
                                                small
                                                color="green lighten-5"
                                                text-color="green lighten-1"
                                            
                                                v-if="item.qualify_status == 1"
                                        >
                                            Qualified
                                        </v-chip>

                                        <v-chip
                                                small
                                                color="red lighten-5"
                                                text-color="red lighten-1"
                                            
                                                v-if="item.qualify_status == -1"
                                        >
                                            Unqualified
                                        </v-chip>

                                        <v-chip
                                                small
                                                color="red darken-2"
                                                text-color="white"
                                            
                                                v-if="item.qualify_status == 2"
                                        >
                                            Spam
                                        </v-chip>

                                        <v-chip v-if="item.qualify_status != 0 && item.qualify_status != 1 && item.qualify_status != 2 && item.qualify_status != -1" :color="getCustomStatusColor(item.qualify_status)"
                                            small
                                            text-color="white"
                                        >
                                            {{ item.qualify_status }}
                                        </v-chip>

                                        <v-menu

                                            

                                                bottom
                                                right

                                                nudge-bottom='25'
                                        >
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-icon v-show="$store.state.auth.owner" color="green" v-bind="attrs" v-on="on" :ripple="false" small class="ml-1">mdi-plus</v-icon>
                                            </template>

                                            <v-list class="table-menu-actions">
                                                <v-list-item class="hover:bg-gray-200">
                                                    <v-list-item-title><a href="javascript: void(0);" @click="item.qualify_status = 1; setQualifyStatus(item, 1);">Qualified</a>
                                                    </v-list-item-title>
                                                </v-list-item>
                                                <v-list-item class="hover:bg-gray-200">
                                                    <v-list-item-title><a href="javascript: void(0);" @click="item.qualify_status = -1; setQualifyStatus(item, -1);">Unqualified</a>
                                                    </v-list-item-title>
                                                </v-list-item>
                                                <v-list-item class="hover:bg-gray-200">
                                                    <v-list-item-title><a href="javascript: void(0);" @click="item.qualify_status = 2; setQualifyStatus(item, 2);">Spam</a>
                                                    </v-list-item-title>
                                                </v-list-item>
                                                <v-list-item class="hover:bg-gray-200">
                                                    <v-list-item-title><a href="javascript: void(0);" @click="item.qualify_status = 0; setQualifyStatus(item, 0);">Not Set</a>
                                                    </v-list-item-title>
                                                </v-list-item>

                                                <v-list-item v-for="(custom_status, status_index) in custom_statuses" :key="'custom-status-' + status_index" class="hover:bg-gray-200">
                                                    <v-list-item-title><a href="javascript: void(0);"><span
                                                        class="table-menu-action-icon" :style="'color: ' + custom_status.color + ';'" @click="item.qualify_status = custom_status.status; setQualifyStatus(item, custom_status.status);">{{ custom_status.status }}</span></a>
                                                    </v-list-item-title>
                                                </v-list-item>

                                                <v-list-item class="hover:bg-gray-200">
                                                    <v-list-item-title><a href="javascript: void(0);" @click="showAddStatus = true">+ Add Status</a></v-list-item-title>
                                                </v-list-item>
                                            </v-list>
                                        </v-menu>
                                    </template>

                                    <template v-slot:item.id="{ item }">

                                        <div style="position: relative;">

                                            <a href="javascript: void(0);" @click="notes_lead = item; show_notes_dialog = true"><i class="mdi mdi-comment-multiple-outline" style="font-size: 16px;"></i></a>

                                            <span v-if="item.notes.length > 0" style="width: 16px;
                                                height: 16px;
                                                line-height: 17px;
                                                font-size: 10px;
                                                background: rgb(255, 112, 67);
                                                color: rgb(255, 255, 255);
                                                padding: 0px !important;
                                                border-radius: 100%;
                                                position: absolute;
                                                font-weight: 600;
                                                text-align: center;
                                                margin-top: -3px;
                                                margin-left: -6px;">{{ item.notes.length }}</span>

                                            &nbsp; &nbsp;

                                            <v-menu
                                                    bottom
                                                    right

                                                    nudge-bottom='25'
                                            >
                                                <template v-slot:activator="{ on, attrs }">
                                                    <v-icon color="green" v-bind="attrs" v-on="on" :ripple="false" small class="ml-1">mdi-dots-vertical</v-icon>
                                                </template>

                                                <v-list class="table-menu-actions">
                                                    <v-list-item class="hover:bg-gray-200">
                                                        <v-list-item-title v-show="item.archived == 0"><a href="javascript: void(0);" @click="archiveLead(item)"><span
                                                            class="table-menu-action-icon"><i
                                                            class="mdi mdi-archive-outline"></i></span> Archive</a>
                                                        </v-list-item-title>
                                                        <v-list-item-title v-show="item.archived == 1"><a href="javascript: void(0);" @click="unArchiveLead(item)"><span
                                                            class="table-menu-action-icon"><i
                                                            class="mdi mdi-package-up"></i></span> Unarchive</a>
                                                        </v-list-item-title>
                                                    </v-list-item>
                                                </v-list>
                                            </v-menu>
                                        </div>
                                    </template>
                                </v-data-table>
                            </div>
                        </div>
                    </v-card>
                </div>
            </template>
        
    </panel-navigation>
</template>

<script>

import { mapState } from 'vuex'
import $ from 'jquery';
import PanelNavigation from '@/components/PanelNavigation.vue'
import InboxThread from '@/views/panel/InboxThread.vue'
import CallModal from  "@/views/panel/Call/Call-Modal.vue"
import axios from 'axios'
import moment from 'moment'
import DialogBuyNumber from '@/components/dialogs/integrations/buyNumber.vue'
import DialogRequestReview from '@/components/dialogs/reviews/requestReview.vue'
import { mixin as clickaway } from 'vue-clickaway';
import ReinforcementLearning from '../../../components/reusable/ReinforcementLearning.vue';

export default {
mixins: [ clickaway ],
    components: {
        CallModal,
        PanelNavigation,
        InboxThread,
        DialogBuyNumber,
        DialogRequestReview,
        ReinforcementLearning
    },
    computed: {
      ...mapState({
          me: (state) => state.me.me,
          profile: (state) => state.me.profile,
      }),
      roiColorClass() {
        if (this.roi > 0) return 'text-green-600';
        if (this.roi < 0) return 'text-red-600';
        return 'text-yellow-500';
      }
    },
data() {
    return {
        selected: [],
        selectedIds: [],
        selectedPhoneNumbers: [],

        show_analysis_dialog: false,

        analyze_queries: [
            {
                description: "",
                type: "string"
            }
        ],

        runningAnalysis: false,
        analysis_totals: null,

        messages: [],
        loading: true,
        thisProc: false,
        show_picker: false,
        
        date_filter: [
              moment().subtract(60, 'days').format('YYYY-MM-DD'),
              moment().format('YYYY-MM-DD')
        ],

        archived_filter: 'Show Unarchived',

        all_time: 0,

        selected_date_text: "Last 60 days",
        
        search: "",

        showAddTag: false,
        showAddStatus: false,

        custom_tags: [],
        custom_statuses: [],

        tags_items: [{
                index: 0,
                text: 'Not Set'
            },{
                index: 1,
                text: 'Existing Customer'
            },{
                index: 2,
                text: 'Missed Call'
            },{
                index: 3,
                text: 'Opportunity'
            },{
                index: 4,
                text: 'Meeting Scheduled'
            },{
                index: 5,
                text: 'Became Customer'
            },{
                index: 'Signed',
                text: 'Signed'
            }
            ,{
                index: 'Booked for Consultation',
                text: 'Booked for Consultation'
            }
            ,{
                index: 'Declined/Not a lead',
                text: 'Declined/Not a lead'
            }
            ,{
                index: 'Wrong Number',
                text: 'Wrong Number'
            }
            ,{
                index: 'No Response',
                text: 'No Response'
            }
            ,{
                index: 'Existing Client',
                text: 'Existing Client'
            }
            ,{
                index: 'Failed Sign Up',
                text: 'Failed Sign Up'
            }
            ,{
                index: 'Following Up/Working on this one',
                text: 'Following Up/Working on this one'
            }
            ,{
                index: 'E-Doc sent not signed',
                text: 'E-Doc sent not signed'
            }
            ,{
                index: 'Booked to Service',
                text: 'Booked to Service'
            }
            ,{
                index: 'Booked for Appointment',
                text: 'Booked for Appointment'
            }
            ,{
                index: 'Cancelled',
                text: 'Cancelled'
            }, {
                index: 'Complete',
                text: 'Complete'
            }, {
                index: 'Incomplete',
                text: 'Incomplete'
            }, {
                index: 'AI Test Call',
                text: 'AI Test Call'
            }, {
                index: 'Duplicate Call',
                text: 'Duplicate Call'
            },
        ],

        qualify_status_items: [{
            index: 0,
            text: 'Not Set'
        },{
            index: 1,
            text: 'Qualified'
        },{
            index: -1,
            text: 'Unqualified'
        },{
            index: 2,
            text: 'Spam'
        }],

        tag: "",
        qualify_status: "",

        headers: [
            { text: 'Phone Number', value: 'customer_phone_number' },
            { text: 'AI Number', value: 'to' },
            { text: 'Lead Type', value: 'lead_type', width: 120 },
            { text: 'Business Category', value: 'lead_category' },
            { text: 'Sources', value: 'sources', width: 120 },
            { text: 'AI Feedback', value: 'ai_feedback', width: 140 },
            { text: 'Creation Date', value: 'lead_creation_date', width: 200 },
            { text: 'Last Updated', value: 'updated_at', width: 200 },
            { text: 'Response Time', value: 'responded_time' },
            { text: 'Location', value: 'geo' },
            { text: 'Job Type', value: 'job_type' },
            { text: 'Charge Status', value: 'charge_status' },
            { text: 'Dispute Status', value: 'dispute_status' },
            { text: 'Value', value: 'value' },
            { text: 'Tags', value: 'tag' },
            { text: 'Status', value: 'qualify_status' },
            { text: '', value: 'id' }
        ],

        diy_headers: [
            { text: 'Phone Number', value: 'customer_phone_number' },
            { text: 'AI Number', value: 'to' },
            { text: 'Lead Type', value: 'lead_type', width: 120 },
            { text: 'Business Category', value: 'lead_category' },
            { text: 'Sources', value: 'sources', width: 120 },
            { text: 'AI Feedback', value: 'ai_feedback', width: 140 },
            { text: 'Creation Date', value: 'lead_creation_date', width: 200 },
            { text: 'Last Updated', value: 'updated_at', width: 200 },
            { text: 'Response Time', value: 'responded_time' },
            { text: 'Location', value: 'geo' },
            { text: 'Job Type', value: 'job_type' },
            { text: 'Value', value: 'value' },
            { text: 'Tags', value: 'tag' },
            { text: '', value: 'id' }
        ],

        headers_custom_comfort: [
            { text: 'Phone Number', value: 'customer_phone_number' },
            { text: 'AI Number', value: 'to' },
            { text: 'Name', value: 'customer_name' },
            { text: 'Address', value: 'address' },
            { text: 'Lead Type', value: 'lead_type', width: 120 },
            { text: 'Business Category', value: 'lead_category' },
            { text: 'Sources', value: 'sources', width: 120 },
            { text: 'Date', value: 'lead_creation_date', width: 200 },
            { text: 'Location', value: 'geo' },
            // { text: 'Charge Status', value: 'charge_status' },
            { text: 'Job Type', value: 'job_type' },
            { text: 'Charge Status', value: 'charge_status' },
            { text: 'Dispute Status', value: 'dispute_status' },
            { text: 'Value', value: 'value' },
            { text: 'Tags', value: 'tag' },
            { text: 'Status', value: 'qualify_status' },
            { text: '', value: 'id' }
        ],

        new_note: "",
        show_notes_dialog: false,
        notes_lead: null,
        savingNote: false,

        exporting: false,

        new_tag: "",
        new_tag_color: "#000000",
        savingTag: false,

        new_status: "",
        new_status_color: "#000000",
        savingStatus: false,

        showCallRailRecording: false,
        loading_callrail_recording: true,
        callrail_recording_data: {},

        showBlandRecording: false,
        loading_bland_recording: true,
        bland_recording_data: {},

        showLsaRecordings: false,
        loading_lsa_recordings: true,

        showLsaMessages: false,
        loading_lsa_messages: true,
        lsa_messages_displayed: [],

        new_lsa_message: "",
        sendingLsaMessage: false,
        lsa_messages_lead: null,

        new_ai_message: "",
        sendingAiMessage: false,
        ai_messages_lead: null,

        lsa_leads_count: 0,
        ai_leads_count: 0,
        ai_leads_count_msg: 0,
        ai_leads_count_voice: 0,
        callrail_leads_count: 0,
        converted_leads_count: 0,
        converted_ai_leads_count: 0,
        converted_human_leads_count: 0,
        booked_leads_count: 0,
        booked_ai_leads_count: 0,
        booked_human_leads_count: 0,
        qualified_leads: 0,
        roi: 0,

        savingAiFeedback: false,
        
        shouldShowChatConversation: false,
        loading_chat_conversation: false
        
    }
},

methods: {
    isSeoTab() {
        return this.$router.currentRoute.name == 'LeadsNewSeo'
    },
    filterBy(text) {
      this.search = text;
      this.getMessages();  
    },
    isOnlyAi() {
      if (this.me.integrations && this.me.integrations.google_ads && this.me.integrations.google_ads.status == 0)
        return true;

      return false;
    },

    async translateTexts(conv_type, language) {
        if (conv_type == 'bland') {
            if (this.bland_recording_data.transcription.messages) {
                for (var i in this.bland_recording_data.transcription.messages) {
                    let theMessage = this.bland_recording_data.transcription.messages[i].body;

                    if (!theMessage) {
                        theMessage = this.bland_recording_data.transcription.messages[i].text
                    }

                    if (!theMessage) {
                        theMessage = this.bland_recording_data.transcription.messages[i].message
                    }

                    let response = await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/me/translate-text`, {
                        source: 'en',
                        target: language,
                        q: theMessage
                    }, {
                        headers: {
                            'Authorization': 'Bearer ' + this.$store.state.auth.jwt
                        }
                    });


                    this.bland_recording_data.transcription.messages[i].body = response.data.data.translations[0].translatedText;
                    this.bland_recording_data.transcription.messages[i].text = response.data.data.translations[0].translatedText;
                    this.bland_recording_data.transcription.messages[i].message = response.data.data.translations[0].translatedText;
                }
            }
            else {
                for (var i in this.bland_recording_data.transcription) {
                    let theMessage = this.bland_recording_data.transcription[i].body;

                    if (!theMessage) {
                        theMessage = this.bland_recording_data.transcription[i].text
                    }

                    if (!theMessage) {
                        theMessage = this.bland_recording_data.transcription[i].message
                    }

                    let response = await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/me/translate-text`, {
                        source: 'en',
                        target: language,
                        q: theMessage
                    }, {
                        headers: {
                            'Authorization': 'Bearer ' + this.$store.state.auth.jwt
                        }
                    });


                    this.bland_recording_data.transcription[i].body = response.data.data.translations[0].translatedText;
                    this.bland_recording_data.transcription[i].text = response.data.data.translations[0].translatedText;
                    this.bland_recording_data.transcription[i].message = response.data.data.translations[0].translatedText;
                }
            }

            this.bland_recording_data = JSON.parse(JSON.stringify(this.bland_recording_data));
        }
    },

    async switchAiResponseEnabled(lead) {
        console.log('lead', lead);

        let response = await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/call-tracking/set-ai-response-enabled`, {
            lead_id: lead.id,
            ai_enabled: lead.ai_enabled
        }, {
            headers: {
                'Authorization': 'Bearer ' + this.$store.state.auth.jwt
            }
        });

        console.log('response', response);
    },
    deleteAnalyzeQuery(theIndex) {
        let new_queries = [];

        for (var i in this.analyze_queries) {
            if (i != theIndex)
                new_queries.push(this.analyze_queries[i]);
        }

        this.analyze_queries = JSON.parse(JSON.stringify(new_queries));
    },

    addAnalysisItem() {
        this.analyze_queries.push({
            description: "",
            type: "string"
        });
    },

    async runAnalysis() {
        this.runningAnalysis = true;

        this.analysis_totals = null;

        let schema = {};

        for (var i in this.analyze_queries) {
            schema[this.analyze_queries[i].description] = this.analyze_queries[i].type;
        }
        
        const options = {
          method: 'POST',
          headers: {authorization: process.env.BLAND_API_KEY, 'Content-Type': 'application/json'},
          body: JSON.stringify({
            queries: [
                {
                    goal: "Run analysis as instructed based on the data provided.",
                    analysis_schema: schema,
                    call_ids: this.selectedIds
                }
            ]
          })
        };

        let self = this;

        fetch('https://api.bland.ai/api/analytics/analysis', options)
            .then(response => response.json())
            .then(data => {
                self.runningAnalysis = false;
                console.log('data', data);
                self.analysis_totals = data.data[0].totals;
            });
    },

    async sendLsaReply() {
        this.sendingLsaMessage = true;
        
        let self = this;

        let response = await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/call-tracking/reply-lsa-message`, {
            lead_id: self.lsa_messages_lead.id,
            message: self.new_lsa_message
        }, {
            headers: {
                'Authorization': 'Bearer ' + this.$store.state.auth.jwt
            }
        });

        let timezone = this.me.timezone;

        this.lsa_messages_displayed.push({
            event_time: moment.tz(timezone).format("YYYY-MM-DD hh:mm:ss"),
            participant_type: 2,
            text: self.new_lsa_message
        });

        this.sendingLsaMessage = false;
        this.new_lsa_message = "";

        setTimeout(function() {
            var objDiv = document.getElementById("lsa-dialog-messages-list");
            objDiv.scrollTop = objDiv.scrollHeight;
        }, 10);
    },

    async sendAiReply() {
        this.sendingAiMessage = true;
        
        let self = this;

        console.log('this.bland_recording_data', this.bland_recording_data);

        if (this.bland_recording_data.sources && this.bland_recording_data.sources.indexOf('lsa') != -1) {
            let response = await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/call-tracking/reply-lsa-message`, {
                lead_id: this.bland_recording_data.id,
                message: self.new_ai_message
            }, {
                headers: {
                    'Authorization': 'Bearer ' + this.$store.state.auth.jwt
                }
            });
        }
        else {
            let response = await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/call-tracking/reply-ai-message`, {
                lead_id: self.ai_messages_lead.id,
                message: self.new_ai_message
            }, {
                headers: {
                    'Authorization': 'Bearer ' + this.$store.state.auth.jwt
                }
            });
        }

        let timezone = this.me.timezone;

        try {
            this.bland_recording_data.transcription.messages.push({
                created_at: moment.tz(timezone).format("YYYY-MM-DD hh:mm:ss"),
                is_bland: 1,
                // is_person: 1,
                message: self.new_ai_message
            });
        }
        catch (e) {

        }

        try {
            this.bland_transcription.messages.push({
                created_at: moment.tz(timezone).format("YYYY-MM-DD hh:mm:ss"),
                is_bland: 1,
                // is_person: 1,
                message: self.new_ai_message,
                content: self.new_ai_message
            });
        }
        catch (e) {

        }

        this.sendingAiMessage = false;
        this.new_ai_message = "";

        try {
            setTimeout(function() {
                var objDiv = document.getElementById("ai-dialog-messages-list");
                objDiv.scrollTop = objDiv.scrollHeight;
            }, 10);
        }
        catch (e) {
        }

        try {
            setTimeout(function() {
                var objDiv = document.getElementById("chat-dialog-messages-list");
                objDiv.scrollTop = objDiv.scrollHeight;
            }, 10);
        }
        catch (e) {
        }
    },

    displaySpeakerTimestamp(milliseconds) {
          //Get hours from milliseconds
          var hours = milliseconds / (1000*60*60);
          var absoluteHours = Math.floor(hours);
          var h = absoluteHours > 9 ? absoluteHours : '0' + absoluteHours;

          //Get remainder from hours and convert to minutes
          var minutes = (hours - absoluteHours) * 60;
          var absoluteMinutes = Math.floor(minutes);
          var m = absoluteMinutes > 9 ? absoluteMinutes : '0' +  absoluteMinutes;

          //Get remainder from minutes and convert to seconds
          var seconds = (minutes - absoluteMinutes) * 60;
          var absoluteSeconds = Math.floor(seconds);
          var s = absoluteSeconds > 9 ? absoluteSeconds : '0' + absoluteSeconds;


          return h + ':' + m + ':' + s;
    },

    async showCallRailRecordingFunction(item) {
        if (this.me.is_medical) return false;

        let self = this;

        this.showCallRailRecording = true;
        this.loading_callrail_recording = true;
        
        this.callrail_recording_data.recording_url = item.call_rail_recording_url;

        let response = await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/call-tracking/get-callrail-transcript`, {
            lead_id: item.id
        }, {
            headers: {
                'Authorization': 'Bearer ' + this.$store.state.auth.jwt
            }
        });

        this.callrail_recording_data.transcription = response.data.transcription;
        this.loading_callrail_recording = false;

        setTimeout(function() {
            document.querySelector('#cr-audio-el-here').innerHTML = '<div class="mr-auto text-xs text-gray-600 pb-2">Recording Timestamp: ' + self.displayTimestamp(item.lead_creation_date) + '</div><audio onwindowresize="" controls="true" class="u-hide" src="' + self.callrail_recording_data.recording_url.replace('/recording', '/recording/redirect') + '" style="width: 100%"></audio>';
        }, 500);

        // <audio onwindowresize="" controls="true" class="u-hide" src="https://app.callrail.com/calls/CALbac64918f74f474fa45d6eb941ab371c/recording?access_key=1a62f6bf96da607431d2"></audio>
        // <audio onwindowresize="" controls="true" class="u-hide" src="https://app.callrail.com/calls/CAL3913e4104efd470a9303bc171e952ce8/recording/redirect?access_key=0f0a785d91552ee6ba6e"></audio>
    },

    async showBlandRecordingFunction(item) {
        if (this.me.is_medical) return false;

        this.ai_messages_lead = item;

        if (this.ai_messages_lead.ai_enabled == 1)
            this.ai_messages_lead.ai_enabled = true;
        else
            this.ai_messages_lead.ai_enabled = false;

        let self = this;

        this.showBlandRecording = true;
        this.loading_bland_recording = true;
        
        this.bland_recording_data.recording_url = item.bland_recording_url;
        this.bland_recording_data.sources = item.sources;
        this.bland_recording_data.id = item.id;

        let response = await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/call-tracking/get-bland-transcript`, {
            lead_id: item.id
        }, {
            headers: {
                'Authorization': 'Bearer ' + this.$store.state.auth.jwt
            }
        });

        this.bland_recording_data.transcription = response.data.transcription;

        let original_ai_messages = JSON.parse(JSON.stringify(this.bland_recording_data.transcription));
        original_ai_messages = original_ai_messages.messages;

        console.log('original_ai_messages', original_ai_messages);

        if (item.lead_type == "MESSAGE" && item.sources.indexOf('lsa') != -1) {
            let response = await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/call-tracking/get-lsa-messages`, {
                lead_id: item.id
            }, {
                headers: {
                    'Authorization': 'Bearer ' + this.$store.state.auth.jwt
                }
            });

            for (var i in response.data.lsa_messages) {
                response.data.lsa_messages[i].sender = ((response.data.lsa_messages[i].participant_type == 3) ? "human" : "bot");
                response.data.lsa_messages[i].is_bland = ((response.data.lsa_messages[i].participant_type == 3) ? 0 : 1);
                response.data.lsa_messages[i].is_person = response.data.lsa_messages[i].is_bland;
                response.data.lsa_messages[i].timestamp = response.data.lsa_messages[i].event_time;
                response.data.lsa_messages[i].message = response.data.lsa_messages[i].text;

                for (var j in original_ai_messages) {
                    console.log('compare 1:', response.data.lsa_messages[i].message);
                    console.log('compare 2:', original_ai_messages[j].body);
                    if (response.data.lsa_messages[i].message == original_ai_messages[j].body) {

                        console.log("FOUD AI MESSAGE");
                        console.log(response.data.lsa_messages[i].message);
                        response.data.lsa_messages[i].is_person = 0;
                        break;
                    }
                }
            }

            this.bland_recording_data.transcription.messages = response.data.lsa_messages;
        }

        this.bland_recording_data.summary = response.data.summary;
        this.bland_recording_data.customer_name = item.customer_name;
        this.bland_recording_data.customer_email = item.customer_email;
        this.bland_recording_data.ai_provided_phone_number = item.ai_provided_phone_number;
        this.bland_recording_data.job_type = item.job_type;
        this.bland_recording_data.call_ended_by = item.call_ended_by;
        this.bland_recording_data.sentiment = response.data.sentiment;
        this.bland_recording_data.topics_discussed = response.data.topics_discussed;
        this.bland_recording_data.issues_raised = response.data.issues_raised;
        this.bland_recording_data.analysis = response.data.analysis;
        this.bland_recording_data.variables = response.data.variables;
        this.loading_bland_recording = false;

        setTimeout(function() {
            if (self.bland_recording_data.recording_url) {
                document.querySelector('#bl-audio-el-here').innerHTML = '<div class="mr-auto text-xs text-gray-600 pb-2">Recording Timestamp: ' + self.displayTimestamp(item.lead_creation_date) + '</div><audio onwindowresize="" controls="true" class="u-hide" src="' + self.bland_recording_data.recording_url.replace(".mp3", ".wav") + '" style="width: 100%"></audio>';
            }
        }, 500);

        setTimeout(function() {
            var objDiv = document.getElementById("ai-dialog-messages-list");
            objDiv.scrollTop = objDiv.scrollHeight;
        }, 10);
    },

    async showLsaCallRecordings(item) {
        if (this.me.is_medical) return false;
        
        let self = this;

        this.showLsaRecordings = true;
        this.loading_lsa_recording = true;

        let response = await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/call-tracking/get-lsa-recordings`, {
            lead_id: item.id
        }, {
            headers: {
                'Authorization': 'Bearer ' + this.$store.state.auth.jwt
            }
        });

        this.loading_lsa_recordings = false;

        if (response.data.recordings.length > 0) {
            let recordings_html = '';

            for (var i in response.data.recordings) {
                recordings_html += '<div class="mr-auto text-xs text-gray-600 pb-2">Recording Timestamp: ' + self.displayTimestamp(item.lead_creation_date) + '</div><div style="margin-bottom: 15px;"><audio onwindowresize="" controls="true" class="u-hide" src="' + response.data.recordings[i] + '" style="width: 100%"></audio></div>';
            }

            setTimeout(function() {
                document.querySelector('#lsa-audio-el-here').innerHTML = recordings_html;
            }, 500);
        }
        else {
            document.querySelector('#lsa-audio-el-here').innerHTML = 'No recordings found.';
        }
    },

    async showLsaMessagesFunction(item) {
    
        // console.log('item.sources', item.sources)
        // console.log('itemplmmmm', item);

        // console.log(1);

        // console.log("item.sources.indexOf('bland')", item.sources.indexOf('bland'))

        if (item.sources.indexOf('bland') != -1) {
            console.log(2);
            this.showBlandRecordingFunction(item);
            return;
        }

        console.log(3);

        if (this.me.is_medical) return false;
        
        let self = this;

        this.showLsaMessages = true;
        this.loading_lsa_messages = true;
        this.lsa_messages_lead = item;

        let response = await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/call-tracking/get-lsa-messages`, {
            lead_id: item.id
        }, {
            headers: {
                'Authorization': 'Bearer ' + this.$store.state.auth.jwt
            }
        });

        this.loading_lsa_messages = false;

        this.lsa_messages_displayed = response.data.lsa_messages;
        this.loading_lsa_messages = false;
    },

    async showChatConversation(item) {
        if (this.me.is_medical) return false;
        
        let self = this;

        this.shouldShowChatConversation = true;
        this.loading_chat_conversation = true;
        this.ai_messages_lead = item;

        if (this.ai_messages_lead.ai_enabled == 1)
            this.ai_messages_lead.ai_enabled = true;
        else
            this.ai_messages_lead.ai_enabled = false;

        let response = await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/call-tracking/get-chat-conversation`, {
            lead_id: item.id
        }, {
            headers: {
                'Authorization': 'Bearer ' + this.$store.state.auth.jwt
            }
        });

        this.bland_transcription = response.data.transcription;
        this.loading_chat_conversation = false;

        setTimeout(function() {
            var objDiv = document.getElementById("chat-dialog-messages-list");
            objDiv.scrollTop = objDiv.scrollHeight;
        }, 10);
    },

    getCustomTagColor(tag) {
        for (var i in this.custom_tags) {
            if (this.custom_tags[i].tag == tag)
                return this.custom_tags[i].color;
        }

        return "";  
    },

    async archiveLead(item) {

        let response = await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/call-tracking/archive-lead`, {
            id: item.id
        }, {
            headers: {
                'Authorization': 'Bearer ' + this.$store.state.auth.jwt
            }
        });

        this.getMessages(true);
    },

    async unArchiveLead(item) {

        let response = await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/call-tracking/unarchive-lead`, {
            id: item.id
        }, {
            headers: {
                'Authorization': 'Bearer ' + this.$store.state.auth.jwt
            }
        });

        this.getMessages(true);
    },

    async saveAiFeedback(item) {
        this.savingAiFeedback = true;
        let response = await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/call-tracking/set-ai-feedback`, {
            lead_id: item.id,
            ai_feedback: item.ai_feedback,
            ai_feedback_urgent: item.ai_feedback_urgent
        }, {
            headers: {
                'Authorization': 'Bearer ' + this.$store.state.auth.jwt
            }
        });

        this.savingAiFeedback = false;
        item.show_ai_feedback = false;
        // this.showAddTag = false;
    },

    async saveTag() {
        this.savingTag = true;
        let response = await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/call-tracking/save-tag`, {
            new_tag: this.new_tag,
            new_tag_color: this.new_tag_color
        }, {
            headers: {
                'Authorization': 'Bearer ' + this.$store.state.auth.jwt
            }
        });

        this.loadCustomTags();
        this.savingTag = false;
        this.showAddTag = false;
        this.new_tag = '';
        this.new_tag_color = '#000000';
    },

    async saveNote() {
        if (!this.new_note)
            return;

        this.savingNote = true;
        let response = await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/call-tracking/add-note`, {
            lead_id: this.notes_lead.id,
            note: this.new_note
        }, {
            headers: {
                'Authorization': 'Bearer ' + this.$store.state.auth.jwt
            }
        });

        this.savingNote = false;
        this.notes_lead = response.data.lsa_lead;
        this.new_note = '';

        this.getMessages(true);
    },

    async deleteNote(index) {
        let response = await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/call-tracking/delete-note`, {
            lead_id: this.notes_lead.id,
            note_index: index
        }, {
            headers: {
                'Authorization': 'Bearer ' + this.$store.state.auth.jwt
            }
        });

        this.notes_lead = response.data.lsa_lead;

        this.getMessages(true);
    },

    async loadCustomTags() {
        let response = await axios.get(`${process.env.VUE_APP_API_ENDPOINT}/call-tracking/load-custom-tags`, {
            headers: {
                'Authorization': 'Bearer ' + this.$store.state.auth.jwt
            }
        });

        this.custom_tags = response.data.custom_tags;

        if (this.isOnlyAi()) {
            this.tags_items = [{
                    index: 0,
                    text: 'Not Set'
                },{
                    index: 1,
                    text: 'Existing Customer'
                },{
                    index: 2,
                    text: 'Missed Call'
                },{
                    index: 5,
                    text: 'Became Customer'
                },
                ,{
                    index: 'Cancelled',
                    text: 'Cancelled'
                }, 
                {
                    index: 'Complete',
                    text: 'Complete'
                }, {
                    index: 'Incomplete',
                    text: 'Incomplete'
                }, {
                    index: 'AI Test Call',
                    text: 'AI Test Call'
                },
            ]
        }
        else {
            this.tags_items = [{
                    index: 0,
                    text: 'Not Set'
                },{
                    index: 1,
                    text: 'Existing Customer'
                },{
                    index: 2,
                    text: 'Missed Call'
                },{
                    index: 3,
                    text: 'Opportunity'
                },{
                    index: 4,
                    text: 'Meeting Scheduled'
                },{
                    index: 5,
                    text: 'Became Customer'
                },{
                    index: 'Signed',
                    text: 'Signed'
                }
                ,{
                    index: 'Booked for Consultation',
                    text: 'Booked for Consultation'
                }
                ,{
                    index: 'Declined/Not a lead',
                    text: 'Declined/Not a lead'
                }
                ,{
                    index: 'Wrong Number',
                    text: 'Wrong Number'
                }
                ,{
                    index: 'No Response',
                    text: 'No Response'
                }
                ,{
                    index: 'Existing Client',
                    text: 'Existing Client'
                }
                ,{
                    index: 'Failed Sign Up',
                    text: 'Failed Sign Up'
                }
                ,{
                    index: 'Following Up/Working on this one',
                    text: 'Following Up/Working on this one'
                }
                ,{
                    index: 'E-Doc sent not signed',
                    text: 'E-Doc sent not signed'
                }
                ,{
                    index: 'Booked to Service',
                    text: 'Booked to Service'
                }
                ,{
                    index: 'Booked for Appointment',
                    text: 'Booked for Appointment'
                }
                ,{
                    index: 'Cancelled',
                    text: 'Cancelled'
                }, 
                {
                    index: 'Complete',
                    text: 'Complete'
                }, {
                    index: 'Incomplete',
                    text: 'Incomplete'
                }, {
                    index: 'AI Test Call',
                    text: 'AI Test Call'
                }, {
                    index: 'Duplicate Call',
                    text: 'Duplicate Call'
                },
            ]
        }

        for (var i in this.custom_tags) {
            this.tags_items.push({
                index: this.custom_tags[i].tag,
                text: this.custom_tags[i].tag
            });
        }
    },

    getCustomStatusColor(status) {
        for (var i in this.custom_statuses) {
            if (this.custom_statuses[i].status == status)
                return this.custom_statuses[i].color;
        }

        return "";  
    },
    async saveStatus() {
        this.savingStatus = true;
        let response = await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/call-tracking/save-status`, {
            new_status: this.new_status,
            new_status_color: this.new_status_color
        }, {
            headers: {
                'Authorization': 'Bearer ' + this.$store.state.auth.jwt
            }
        });

        this.loadCustomStatuses();
        this.savingStatus = false;
        this.showAddStatus = false;
        this.new_status = '';
        this.new_status_color = '#000000';
    },

    async loadCustomStatuses() {
        let response = await axios.get(`${process.env.VUE_APP_API_ENDPOINT}/call-tracking/load-custom-statuses`, {
            headers: {
                'Authorization': 'Bearer ' + this.$store.state.auth.jwt
            }
        });

        this.custom_statuses = response.data.custom_statuses;

        this.qualify_status_items = [{
            index: 0,
            text: 'Not Set'
        },{
            index: 1,
            text: 'Qualified'
        },{
            index: -1,
            text: 'Unqualified'
        },{
            index: 2,
            text: 'Spam'
        }]

        for (var i in this.custom_statuses) {
            this.qualify_status_items.push({
                index: this.custom_statuses[i].status,
                text: this.custom_statuses[i].status
            });
        }
    },

    formatDate: function(date, format = "MM/DD/YYYY") {
        return moment(String(date)).format(format)
    },

    displayTimestamp(date) {
        let timezone = this.me.timezone;

        // .tz(timezone)
        return moment.utc(date).format('ddd M/D YYYY h:mm:ss A');
    },

    displayDuration(seconds) {
        return date;
    },

    displayDuration(time) {
        var sec_num = time // don't forget the second param
        var hours   = Math.floor(sec_num / 3600);
        var minutes = Math.floor((sec_num - (hours * 3600)) / 60);
        var seconds = sec_num - (hours * 3600) - (minutes * 60);

        if (hours   < 10) {hours   = "0"+hours;}
        if (minutes < 10) {minutes = "0"+minutes;}
        if (seconds < 10) {seconds = "0"+seconds;}
        return hours+':'+minutes+':'+seconds;
    },

    formatPhoneNumber(phoneNumberString) {
        const match = phoneNumberString
.replace(/\D+/g, '').replace(/^1/, '')
.match(/([^\d]*\d[^\d]*){1,10}$/)[0]
const part1 = match.length > 2 ? `(${match.substring(0,3)})` : match
const part2 = match.length > 3 ? ` ${match.substring(3, 6)}` : ''
const part3 = match.length > 6 ? `-${match.substring(6, 10)}` : ''    
return `${part1}${part2}${part3}`
    },

    playAudio(item) {
        if (document.getElementById('audio-element-wrapper-' + item.id).style.display == 'none') {
            let elements = document.getElementsByClassName('audio-element-wrapper');

            for (var i in elements) {
                try {
                    elements[i].style.display = 'none';
                }
                catch (e) {}
            }

            let elements2 = document.getElementsByClassName('audio-element');

            for (var i in elements) {
                try {
                    elements2[i].pause();
                    elements2[i].currentTime = 0;
                }
                catch (e) {}
            }

            let elements3 = document.getElementsByClassName('audio-element-icon');

            for (var i in elements) {
                try {
                    elements3[i].style.display = 'block';
                }
                catch (e) {}
            }

            document.getElementById('audio-element-wrapper-' + item.id).style.display = 'block';
            document.getElementById('audio-element-' + item.id).play();

            document.getElementById('audio-element-icon-' + item.id).style.display = 'none';

            
        }
        else {
            document.getElementById('audio-element-wrapper-' + item.id).style.display = 'none';
            document.getElementById('audio-element-' + item.id).pause();
            document.getElementById('audio-element-' + item.id).currentTime = 0;

            document.getElementById('audio-element-icon-' + item.id).style.display = 'block';
        }
    },

    showEditValue(item) {
        $('.lsa-show-value-' + item.id).hide();
        $('.lsa-edit-value-' + item.id).show();
        setTimeout(function() {
            $('.lsa-edit-value-' + item.id).focus();
        }, 20);
    },

    cancelEditValue(item) {
        $('.lsa-show-value-' + item.id).show();
        $('.lsa-edit-value-' + item.id).hide();
    },

    async editValue(item) {
        item.value = $('.lsa-edit-value-' + item.id + ' input').val();
        let response = await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/call-tracking/edit-value-message`, {
            item: item
        }, {
            headers: {
                'Authorization': 'Bearer ' + this.$store.state.auth.jwt
            }
        });

        this.getMessages(true);

        $('.lsa-show-value').show();
        $('.lsa-edit-value').hide();
    },

    showEditCustomerName(item) {
        $('.lsa-show-customer-name-' + item.id).hide();
        $('.lsa-edit-customer-name-' + item.id).show();
        setTimeout(function() {
            $('.lsa-edit-customer-name-' + item.id).focus();
        }, 20);
    },

    cancelEditCustomerName(item) {
        $('.lsa-show-customer-name-' + item.id).show();
        $('.lsa-edit-customer-name-' + item.id).hide();
    },

    async editCustomerName(item) {
        item.customer_name = $('.lsa-edit-customer-name-' + item.id + ' input').val();
        let response = await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/call-tracking/edit-customer-name`, {
            item: item
        }, {
            headers: {
                'Authorization': 'Bearer ' + this.$store.state.auth.jwt
            }
        });

        this.getMessages(true);

        $('.lsa-show-customer-name').show();
        $('.lsa-edit-customer-name').hide();
    },

    showEditAddress(item) {
        $('.lsa-show-address-' + item.id).hide();
        $('.lsa-edit-address-' + item.id).show();
        setTimeout(function() {
            $('.lsa-edit-address-' + item.id).focus();
        }, 20);
    },

    cancelEditAddress(item) {
        $('.lsa-show-address-' + item.id).show();
        $('.lsa-edit-address-' + item.id).hide();
    },

    async editAddress(item) {
        item.address = $('.lsa-edit-address-' + item.id + ' input').val();
        let response = await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/call-tracking/edit-address`, {
            item: item
        }, {
            headers: {
                'Authorization': 'Bearer ' + this.$store.state.auth.jwt
            }
        });

        this.getMessages(true);

        $('.lsa-show-address').show();
        $('.lsa-edit-address').hide();
    },

    filterDate() {
        console.log(this.date_filter.length);
        if (!this.date_filter[1])
            return;

        this.show_picker = false;
        this.getMessages();
    },

      applyDate(selected_date) {
        this.all_time = 0;
        // console.log('selected_date', selected_date);
        this.selected_date_text = selected_date;
        switch (selected_date) {
          case 'This Week':
            this.date_filter[0] = moment().startOf('week').format('YYYY-MM-DD');
            this.date_filter[1] = moment().endOf('week').format('YYYY-MM-DD');
          break;
          case 'Last Week':
            this.date_filter[0] = moment().startOf('week').subtract(7, 'days').format('YYYY-MM-DD');
            this.date_filter[1] = moment().endOf('week').subtract(7, 'days').format('YYYY-MM-DD');
          break;
          case 'This Month':
            this.date_filter[0] = moment().startOf('month').format('YYYY-MM-DD');
            this.date_filter[1] = moment().endOf('month').format('YYYY-MM-DD');
          break;
          case 'Last Month':
            this.date_filter[0] = moment().subtract(1, 'month').startOf('month').format('YYYY-MM-DD');
            this.date_filter[1] = moment().subtract(1, 'month').endOf('month').format('YYYY-MM-DD');
          break;
          case 'Last 60 days':
            this.date_filter[0] = moment().subtract(60, 'days').format('YYYY-MM-DD');
            this.date_filter[1] = moment().format('YYYY-MM-DD');
          break;
          case 'Last 90 days':
            this.date_filter[0] = moment().subtract(90, 'days').format('YYYY-MM-DD');
            this.date_filter[1] = moment().format('YYYY-MM-DD');
          break;
          case 'This Year':
            this.date_filter[0] = moment().startOf('year').format('YYYY-MM-DD');
            this.date_filter[1] = moment().endOf('year').format('YYYY-MM-DD');
          break;
          case 'Last Year':
            this.date_filter[0] = moment().startOf('year').subtract(1, 'year').format('YYYY-MM-DD');
            this.date_filter[1] = moment().endOf('year').subtract(1, 'year').format('YYYY-MM-DD');
          break;

          case 'All Time':
            this.date_filter[0] = moment().startOf('year').subtract(10, 'years').format('YYYY-MM-DD');
            this.date_filter[1] = moment().format('YYYY-MM-DD');
            
            this.all_time = 1;
          break;
        }
        // console.log(this.date_filter);
        this.show_picker = false;
        this.getMessages();
      },

    async getMessages(silent = false) {
        let self = this;

        if (!silent)
            this.loading = true;

        let response = await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/call-tracking/get-messages`, {
            date_filter: this.date_filter,
            search: this.search,
            tag: this.tag,
            qualify_status: this.qualify_status,
            archived_filter: this.archived_filter,
            is_seo: 1
        }, {
            headers: {
                'Authorization': 'Bearer ' + this.$store.state.auth.jwt
            }
        })

        this.messages = response.data.messages;
        this.lsa_leads_count = response.data.lsa_leads_count;
        this.ai_leads_count = response.data.ai_leads_count;
        this.ai_leads_count_msg = response.data.ai_leads_count_msg;
        this.ai_leads_count_voice = response.data.ai_leads_count_voice;
        this.callrail_leads_count = response.data.callrail_leads_count;
        this.converted_leads_count = response.data.converted_leads_count;
        this.converted_ai_leads_count = response.data.converted_ai_leads_count;
        this.converted_human_leads_count = response.data.converted_human_leads_count;
        this.booked_leads_count = response.data.booked_leads_count;
        this.booked_ai_leads_count = response.data.booked_ai_leads_count;
        this.booked_human_leads_count = response.data.booked_human_leads_count;
        this.qualified_leads = response.data.qualified_leads;
        this.roi = response.data.roi;
        this.loading = false;

        if (this.$route.query.tconv) {
            // https://organic-train-7vqj4qq9x9hrgp5-8080.app.github.dev/login?alt=ZXlKMGVYQWlPaUpLVjFRaUxDSmhiR2NpT2lKSVV6STFOaUo5LmV5SnBjM01pT2lKb2RIUndjenBjTDF3dmJITmhMbkpoZG5VdWJXVmNMM1JqYjI1Mklpd2lhV0YwSWpveE56TXdORFkwT1RFeUxDSmxlSEFpT2pFM016RXdOamszTVRJc0ltNWlaaUk2TVRjek1EUTJORGt4TWl3aWFuUnBJam9pYW1WM1pHZE9Xa2htUmt0aWNVMHlUQ0lzSW5OMVlpSTZNVEF6TXl3aWNISjJJam9pTWpOaVpEVmpPRGswT1dZMk1EQmhaR0l6T1dVM01ERmpOREF3T0RjeVpHSTNZVFU1TnpabU55SjkueU5PbmtGUlFmaWZ6YlI2MzBmYlRhZ1Y0bHp5MW12QWtCNXpSNVlROHdoMA==&redirect=%2Fleads%3Ftconv%3D162368

            // this.showBlandRecording = showBlandRecordingFunction(item);

            tryClick();

            function tryClick() {
                try {
                    console.log('trying...');
                    document.querySelector("#sblrcfncc-" + this.$route.query.tconv).click();
                }
                catch(e) {
                    setTimeout(function() {
                        tryClick();
                    }, 100);
                }
            }
        }
    },

    async setTag(item, tag) {
        let response = await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/call-tracking/set-tag-message`, {
            message_id: item.id,
            tag: tag
        }, {
            headers: {
                'Authorization': 'Bearer ' + this.$store.state.auth.jwt
            }
        })

        this.getMessages(true);
    },

    async removeTag(item, tag) {
        let response = await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/call-tracking/remove-tag-message`, {
            message_id: item.id,
            tag: tag
        }, {
            headers: {
                'Authorization': 'Bearer ' + this.$store.state.auth.jwt
            }
        })

        this.getMessages(true);
    },

    async setQualifyStatus(item, qualify_status) {
        let response = await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/call-tracking/set-qualify-status-message`, {
            message_id: item.id,
            qualify_status: qualify_status
        }, {
            headers: {
                'Authorization': 'Bearer ' + this.$store.state.auth.jwt
            }
        })

        this.getMessages(true);
    },

    downloadCsv() {
        this.exporting = true;

        let self = this;

        let csv = 'Timestamp, Customer Name, Lead Number, Job Type, Postal Code, Tag, Status\n';
        this.messages.forEach((row) => {

            let tag = 'Not Set';

            for (var i in this.tags_items) {
                if (this.tags_items[i].index == row.tag)
                    tag = this.tags_items[i].text
            }

            let status = 'Not Set';

            for (var i in this.qualify_status_items) {
                if (this.qualify_status_items[i].index == row.qualify_status)
                    status = this.qualify_status_items[i].text
            }

            let csv_data = [
                '"' + self.displayTimestamp(row.lead_creation_date) + '"',
                '"' + row.customer_name + '"',
                row.customer_phone_number,
                '"' + row.job_type.replace(/\_/g, " ").toLowerCase().replace(/\b[a-z]/g, function(letter) { return letter.toUpperCase(); }) + '"',
                '"' + row.postal_code + '"',
                tag,
                status
            ]

            csv += csv_data.join(',');
            csv += "\n";
        });
    
        const anchor = document.createElement('a');
        anchor.href = 'data:text/csv;charset=utf-8,' + encodeURIComponent(csv);
        anchor.target = '_blank';
        anchor.download = 'calls-' + this.date_filter.join("-") + ".csv";
        anchor.click();

        this.exporting = false;
    },

    async doCreated() {
        if (!this.me)
            await this.$store.dispatch('me/fetch')

        let self = this
        self.getMessages();
        self.loadCustomTags();
        self.loadCustomStatuses();

        // this.thisProc = setInterval(function() {
        //     self.getMessages(true);
        // }, 5000);
    }
},

destroyed() {
    clearTimeout(this.thisProc);
    this.thisProc = null;
},

created() {
    this.doCreated();
},
  watch: {
    selected: {
      handler() {
        this.selectedIds = [];
        this.selectedPhoneNumbers = [];

        for (var i in this.selected) {
            if (this.selected[i].bland_sid) {
                this.selectedIds.push(this.selected[i].bland_sid);
            }

            if (this.selected[i].customer_phone_number) {
                this.selectedPhoneNumbers.push(this.selected[i].customer_phone_number);
            }
        }
      }
    }
  },
}
</script>


<style scoped>
.custom-text-field .v-input__control input {
border-color: white !important;
}

.v-text-field--outlined fieldset {
border: 1px solid red;
}
.header-inputs {
border-color: white !important;
}

.theme--light.v-text-field--outlined:not(.v-input--is-focused):not(.v-input--has-state) > .v-input__control > .v-input__slot fieldset {
color: rgba(0, 0, 0, 0.38);
border-color: white !important;
}

.v-text-field--outlined fieldset {
border: 1px solid white !important;
}

.status-chip {
font-weight: bold;
text-transform: uppercase;
}

.status-Qualified {
color: green !important;
border-color: green !important;

}

.status-inQualified {
color: red;
border-color: red;
}

.custom-badge {
background-color: rgba(0, 230, 130, 0.1) !important;
color: #09ad95 !important;
}

.tags {
color: #e0e0e0;
font-size: small;
padding-left: 5px;

}

.icon-container {
display: flex;
align-items: center;
justify-content: center;
width: 48px;
height: 48px;
border-radius: 50%;
border: 2px solid #ccc;
cursor: pointer;
}

.icon {
font-size: 24px;
}

textarea:focus, input:focus{
    outline: none;
}

.stats-btn .stats-div {
    display: none;
}

.stats-btn:hover .stats-div {
    display: block;
}
</style>